import {
  AlertCircle,
  AlertTriangle,
  ArrowDown,
  ArrowUp,
  ArrowUpRight,
  Banknote,
  Calendar,
  ChevronDown,
  ChevronRight,
  CircleHelp,
  Copy,
  CreditCard,
  DollarSign,
  Download,
  Eye,
  EyeOff,
  Flame,
  Gift,
  HandCoins,
  Info,
  KeyRound,
  List,
  LogIn,
  LogOut,
  LucideProps,
  Mail,
  Minus,
  Plus,
  Search,
  Send,
  Trash,
  Trash2,
  Upload,
  Wallet,
  X,
  Check,
  RefreshCcw,
  CircleCheck,
} from 'lucide-react';

export const Icons = {
  arrowDown: ArrowDown,
  arrowUp: ArrowUp,
  arrowUpRight: ArrowUpRight,
  banknote: Banknote,
  chevronDown: ChevronDown,
  chevronRight: ChevronRight,
  calendar: Calendar,
  check: Check,
  circleCheck: CircleCheck,
  close: X,
  copy: Copy,
  creditCard: CreditCard,
  depositIcon: Download,
  dolarSign: DollarSign,
  error: AlertCircle,
  flame: Flame,
  handCoins: HandCoins,
  hideEye: EyeOff,
  info: Info,
  keyRound: KeyRound,
  list: List,
  login: LogIn,
  logout: LogOut,
  mail: Mail,
  minus: Minus,
  numberArrow: ArrowUp,
  plus: Plus,
  question: CircleHelp,
  refresh: RefreshCcw,
  rewards: Gift,
  search: Search,
  send: Send,
  showEye: Eye,
  trash: Trash,
  trash2: Trash2,
  warning: AlertTriangle,
  wallet: Wallet,
  withdraw: Upload,
  x: X,
  apple: (props: LucideProps) => (
    <svg viewBox="0 0 32 32" fill="none" {...props}>
      <path
        d="M0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16Z"
        fill="white"
      />
      <path
        d="M22.5209 12.4777C22.4141 12.5633 20.5273 13.6597 20.5273 16.0976C20.5273 18.9175 22.9281 19.9151 23 19.9398C22.9889 20.0006 22.6186 21.306 21.7342 22.6362C20.9456 23.8067 20.122 24.9753 18.8691 24.9753C17.6161 24.9753 17.2937 24.2247 15.8473 24.2247C14.4378 24.2247 13.9366 25 12.7906 25C11.6445 25 10.8449 23.9169 9.92544 22.5868C8.86046 21.0248 8 18.5983 8 16.2952C8 12.6013 10.329 10.6422 12.6211 10.6422C13.839 10.6422 14.8542 11.4668 15.6188 11.4668C16.3466 11.4668 17.4816 10.5928 18.8672 10.5928C19.3923 10.5928 21.2791 10.6422 22.5209 12.4777ZM18.2094 9.0289C18.7825 8.32773 19.1878 7.35484 19.1878 6.38194C19.1878 6.24702 19.1768 6.11021 19.1528 6C18.2205 6.0361 17.1113 6.64036 16.4425 7.44034C15.9173 8.05601 15.4272 9.0289 15.4272 10.0151C15.4272 10.1633 15.4512 10.3115 15.4622 10.359C15.5212 10.3704 15.617 10.3837 15.7128 10.3837C16.5493 10.3837 17.6014 9.80608 18.2094 9.0289Z"
        fill="black"
      />
    </svg>
  ),
  chart: (props: LucideProps) => (
    <svg viewBox="0 0 17 17" fill="none" {...props}>
      <path
        d="M4.8321 6.99123L0.296313 11.4835C0.106686 11.6713 0 11.9271 0 12.194V15.2412C0 15.7935 0.447715 16.2412 1 16.2412H16C16.5523 16.2412 17 15.7935 17 15.2412V4.04962C17 3.06126 15.719 2.67198 15.1691 3.49325L11.371 9.16563C11.0651 9.62244 10.4478 9.74668 9.98905 9.44376L6.08678 6.86724C5.69189 6.60651 5.16831 6.65825 4.8321 6.99123Z"
        fill="url(#paint0_linear_2879_195431)"
        fillOpacity="0.39"
      />
      <path
        d="M1 11.4912L5.77273 6.15788L10.5455 9.71343L16 3.49121"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="13" cy="6.75879" r="2" fill="#80CA9B" />
      <defs>
        <linearGradient
          id="paint0_linear_2879_195431"
          x1="11.3958"
          y1="-0.902728"
          x2="11.3958"
          y2="29.4191"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#9DD9FB" />
          <stop offset="1" stopColor="#9DD9FB" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  ),
  claimRewards: (props: LucideProps) => (
    <svg viewBox="0 0 23 17" fill="none" {...props}>
      <path
        d="M3.51914 4.16992L1.11914 7.09992L9.07914 10.8799L11.4991 7.38992L3.51914 4.16992Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.7388 4.16992L22.1388 7.09992L14.1788 10.8799L11.7588 7.38992L19.7388 4.16992Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.50879 8.47998V12.43L11.4988 16.06L19.0288 12.43V8.65998"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4189 13.09V8.47998"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4189 4.97982V2.06982"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6494 2.33008L19.7694 4.17008"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.62879 2.33008L3.50879 4.17008"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.00879 3.26986L11.4188 0.859863L13.8188 3.26986"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  copied: ({
    fill = '#58BD7D',
    width = '18',
    height = '19',
    ...rest
  }: LucideProps) => (
    <svg
      viewBox="0 0 18 19"
      fill="none"
      width={width}
      height={height}
      {...rest}>
      <circle cx="9" cy="9.5" r="9" fill={fill} />
      <path
        d="M5.5 9.45381L8.25 11.9993L13 6.99927"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),
  cosmoStation: (props: LucideProps) => (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M17.3434 2.71582H9.64819C9.45647 2.716 9.26816 2.76654 9.1021 2.86238C8.93605 2.95822 8.79809 3.09599 8.70202 3.26191L4.85438 9.92566C4.75818 10.0916 4.70752 10.28 4.70752 10.4718C4.70752 10.6635 4.75818 10.8519 4.85438 11.0179L8.70202 17.6816L10.5941 16.5895L7.06367 10.4718L10.2797 4.9002H16.7146L20.2478 11.0178L22.1399 9.92562L18.2894 3.26191C18.1936 3.09579 18.0557 2.95785 17.8896 2.86198C17.7236 2.76611 17.5351 2.7157 17.3434 2.71582Z"
        fill="#9C6CFF"
        // style="fill:#9C6CFF;fill:color(display-p3 0.6118 0.4235 1.0000);fill-opacity:1;"
        fillOpacity="1"
      />
      <path
        d="M15.2749 6.33691L13.3828 7.4291L16.916 13.5468L13.7 19.1183H7.26516L3.73195 13.0006L1.83984 14.0929L5.68748 20.7566C5.78336 20.9227 5.92127 21.0606 6.08734 21.1564C6.25341 21.2523 6.44179 21.3028 6.63354 21.3027H14.3288C14.5205 21.3025 14.7088 21.252 14.8749 21.1561C15.0409 21.0603 15.1788 20.9225 15.2749 20.7566L19.1225 14.0929C19.2187 13.927 19.2694 13.7386 19.2694 13.5468C19.2694 13.355 19.2187 13.1666 19.1225 13.0007L15.2749 6.33691Z"
        fill="#05D2DD"
        // style="fill:#05D2DD;fill:color(display-p3 0.0196 0.8235 0.8667);fill-opacity:1;"
        fillOpacity="1"
      />
    </svg>
  ),
  depositRounded: (props: LucideProps) => (
    <svg viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M16.7679 8.23214C16.9554 8.86607 17 9.3125 17 10C17 13.8482 13.8482 17 10 17C6.15179 17 3 13.8482 3 10C3 6.15179 6.15179 3 10 3C10.8482 3 11.6518 3.15179 12.4107 3.42857"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1428 7.46401V12.8211M10.1428 12.8211L12.8214 10.1426M10.1428 12.8211L7.46427 10.1426"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  detailArrow: ({width = '8', height = '4', ...rest}: LucideProps) => (
    <svg width={width} height={height} viewBox="0 0 8 4" {...rest}>
      <path d="M8 4L4 -3.49691e-07L0 4" fill="currentColor" />
    </svg>
  ),
  discord: (props: LucideProps) => (
    <svg viewBox="0 0 33 32" fill="none" {...props}>
      <g clipPath="url(#clip0_283_5665)">
        <path
          d="M16.25 32C25.0866 32 32.25 24.8366 32.25 16C32.25 7.16344 25.0866 0 16.25 0C7.41344 0 0.25 7.16344 0.25 16C0.25 24.8366 7.41344 32 16.25 32Z"
          fill="#5865F2"
          // style="fill:#5865F2;fill:color(display-p3 0.3451 0.3961 0.9490);fill-opacity:1;"
          fillOpacity="1"
        />
        <path
          d="M21.7946 10.9061C20.7572 10.43 19.6624 10.0905 18.5377 9.89614C18.5275 9.89419 18.5169 9.89552 18.5074 9.89996C18.498 9.90439 18.4902 9.9117 18.4852 9.92083C18.3358 10.1915 18.2003 10.4696 18.0789 10.754C16.8666 10.5698 15.6334 10.5698 14.4211 10.754C14.2993 10.4689 14.1618 10.1907 14.0093 9.92083C14.004 9.91189 13.9962 9.90474 13.9868 9.90034C13.9775 9.89593 13.967 9.89447 13.9568 9.89614C12.8323 10.0902 11.7379 10.4297 10.7011 10.9061C10.6922 10.9099 10.6847 10.9163 10.6796 10.9246C8.6055 14.0236 8.03738 17.0464 8.31613 20.0311C8.31692 20.0385 8.31919 20.0456 8.32278 20.052C8.32638 20.0585 8.33124 20.0641 8.33706 20.0686C9.54482 20.9633 10.8958 21.6463 12.3324 22.0883C12.3425 22.0914 12.3533 22.0912 12.3634 22.0879C12.3734 22.0846 12.3822 22.0783 12.3886 22.0699C12.6971 21.65 12.9704 21.2053 13.2058 20.7405C13.209 20.7341 13.2109 20.7271 13.2112 20.72C13.2115 20.7129 13.2103 20.7058 13.2077 20.6991C13.205 20.6925 13.201 20.6865 13.1959 20.6815C13.1908 20.6765 13.1847 20.6727 13.178 20.6702C12.7469 20.5056 12.3296 20.307 11.9299 20.0764C11.9226 20.0722 11.9165 20.0662 11.9121 20.059C11.9077 20.0518 11.9052 20.0437 11.9047 20.0353C11.9042 20.0269 11.9058 20.0185 11.9093 20.0108C11.9128 20.0032 11.9182 19.9965 11.9249 19.9914C12.0086 19.9289 12.0927 19.8633 12.1727 19.7971C12.1798 19.7912 12.1884 19.7875 12.1975 19.7863C12.2066 19.7851 12.2159 19.7864 12.2243 19.7902C14.8427 20.9858 17.6777 20.9858 20.2652 19.7902C20.2736 19.7862 20.283 19.7846 20.2923 19.7857C20.3016 19.7868 20.3104 19.7905 20.3177 19.7964C20.3977 19.8624 20.4818 19.9286 20.5677 19.9914C20.5744 19.9965 20.5798 20.0031 20.5834 20.0107C20.587 20.0183 20.5886 20.0267 20.5882 20.0351C20.5877 20.0435 20.5852 20.0517 20.5809 20.0589C20.5766 20.0661 20.5705 20.0721 20.5633 20.0764C20.1641 20.3092 19.746 20.5079 19.3133 20.6702C19.3066 20.6727 19.3004 20.6767 19.2953 20.6818C19.2902 20.6869 19.2863 20.693 19.2837 20.6997C19.2811 20.7064 19.28 20.7136 19.2804 20.7208C19.2808 20.728 19.2828 20.7351 19.2861 20.7414C19.5255 21.2037 19.7984 21.6478 20.1027 22.0702C20.1089 22.0789 20.1176 22.0854 20.1277 22.0888C20.1378 22.0923 20.1488 22.0924 20.1589 22.0893C21.5975 21.6485 22.9502 20.9654 24.1589 20.0696C24.1649 20.0653 24.1698 20.0598 24.1734 20.0534C24.177 20.047 24.1792 20.04 24.1799 20.0327C24.5136 16.5814 23.6211 13.5833 21.8143 10.9258C21.8102 10.9171 21.8032 10.9102 21.7946 10.9061ZM13.5964 18.2139C12.808 18.2139 12.1589 17.4902 12.1589 16.6014C12.1589 15.7127 12.7958 14.9889 13.5964 14.9889C14.4036 14.9889 15.0471 15.7189 15.0339 16.6014C15.0346 17.4902 14.3974 18.2139 13.5964 18.2139ZM18.913 18.2139C18.1246 18.2139 17.4755 17.4902 17.4755 16.6014C17.4755 15.7127 18.1124 14.9889 18.913 14.9889C19.7202 14.9889 20.3636 15.7189 20.3505 16.6014C20.3508 17.4902 19.7202 18.2139 18.913 18.2139Z"
          fill="white"
          fillOpacity="1"
        />
      </g>
      <defs>
        <clipPath id="clip0_283_5665">
          <rect
            width="32"
            height="32"
            fill="white"
            fillOpacity="1"
            transform="translate(0.25)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  dottedLine: ({width = '159', height = '6', ...rest}: LucideProps) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 159 6"
      fill="none"
      {...rest}>
      <path
        d="M1 3H151"
        stroke="url(#paint0_linear_460_900)"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeDasharray="0.1 5"
      />
      <path d="M155 6L159 3L155 0" fill="black" />
      <defs>
        <linearGradient
          id="paint0_linear_460_900"
          x1="146.604"
          y1="4.24994"
          x2="0.249478"
          y2="5.99899"
          gradientUnits="userSpaceOnUse">
          <stop />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  ),
  dottedLineDark: ({width = 159, height = 7, ...rest}: LucideProps) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 159 7"
      fill="none"
      {...rest}>
      <path
        d="M1 3.5H151"
        stroke="url(#paint0_linear_622_17075)"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeDasharray="0.1 5"
      />
      <path d="M155 6.5L159 3.5L155 0.5" fill="#FBFBFB" />
      <defs>
        <linearGradient
          id="paint0_linear_622_17075"
          x1="146.604"
          y1="4.74994"
          x2="0.249478"
          y2="6.49899"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  ),
  dottedLineSmall: ({width = 86, height = 6, ...rest}: LucideProps) => (
    <svg width={width} height={height} viewBox="0 0 86 6" fill="none" {...rest}>
      <path
        d="M1 3.5H78"
        stroke="url(#paint0_linear_710_14402)"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeDasharray="0.1 5"
      />
      <path d="M82 6L86 3L82 0" fill="#1D1D1F" />
      <defs>
        <linearGradient
          id="paint0_linear_710_14402"
          x1="75.7435"
          y1="4.74994"
          x2="0.60683"
          y2="5.21088"
          gradientUnits="userSpaceOnUse">
          <stop />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  ),
  dottedLineSmallDark: ({width = 86, height = 35, ...rest}: LucideProps) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 86 35"
      fill="none"
      {...rest}>
      <path
        d="M1 18H78"
        stroke="url(#paint0_linear_622_28394)"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeDasharray="0.1 5"
      />
      <path d="M82 20.5L86 17.5L82 14.5" fill="#FBFBFB" />
      <circle cx="43" cy="17.5" r="17" fill="#1A2736" />
      <circle
        cx="43"
        cy="17.5"
        r="16.25"
        stroke="#E5E5E5"
        strokeOpacity="0.1"
        strokeWidth="1.5"
      />
      <path
        d="M36.3141 19.5972L50.3674 19.5972L46.5366 23.8672"
        stroke="#FBFBFB"
        strokeWidth="1.3175"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.3674 16.084L36.3141 16.084L40.1449 11.814"
        stroke="#FBFBFB"
        strokeWidth="1.3175"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="32.814"
        y="28.3677"
        width="21.0536"
        height="21.0536"
        transform="rotate(-90 32.814 28.3677)"
        stroke="#E5E5E5"
        strokeOpacity="0.1"
        strokeWidth="0.02635"
      />
      <defs>
        <linearGradient
          id="paint0_linear_622_28394"
          x1="75.7435"
          y1="19.2499"
          x2="0.60683"
          y2="19.7109"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  ),
  edit: ({width = 18, height = 19, ...rest}: LucideProps) => (
    <svg
      viewBox="0 0 18 19"
      fill="none"
      width={width}
      height={height}
      {...rest}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M9 15.5h6.75M12.375 3.125a1.591 1.591 0 1 1 2.25 2.25L5.25 14.75l-3 .75.75-3 9.375-9.375Z"
      />
    </svg>
  ),
  facebook: (props: LucideProps) => (
    <svg viewBox="0 0 32 32" fill="none" {...props}>
      <path
        d="M32 16C32 7.1635 24.8365 0 16 0C7.1635 0 0 7.16337 0 16C0 23.986 5.851 30.6054 13.5 31.8056V20.625H9.4375V16H13.5V12.475C13.5 8.465 15.8888 6.25 19.5434 6.25C21.294 6.25 23.125 6.5625 23.125 6.5625V10.5H21.1075C19.1198 10.5 18.5 11.7334 18.5 12.9987V16H22.9375L22.2281 20.625H18.5V31.8056C26.149 30.6054 32 23.9861 32 16Z"
        fill="#1877F2"
        // style="fill:#1877F2;fill:color(display-p3 0.0941 0.4667 0.9490);fill-opacity:1;"
        fillOpacity="1"
      />
      <path
        d="M22.2281 20.625L22.9375 16H18.5V12.9987C18.5 11.7332 19.1199 10.5 21.1075 10.5H23.125V6.5625C23.125 6.5625 21.294 6.25 19.5434 6.25C15.8888 6.25 13.5 8.465 13.5 12.475V16H9.4375V20.625H13.5V31.8056C14.327 31.9352 15.1629 32.0002 16 32C16.8371 32.0002 17.673 31.9353 18.5 31.8056V20.625H22.2281Z"
        fill="white"
        fillOpacity="1"
      />
    </svg>
  ),
  faucet: (props: LucideProps) => (
    <svg viewBox="0 0 18 19" fill="none" {...props}>
      <g clipPath="url(#clip0_3698_2417)">
        <path
          d="M9.5697 8.90202C13.8186 8.90202 17.2629 7.18578 17.2629 5.06868C17.2629 2.95159 13.8186 1.23535 9.5697 1.23535C5.32084 1.23535 1.87646 2.95159 1.87646 5.06868C1.87646 7.18578 5.32084 8.90202 9.5697 8.90202Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.56997 3.31396C11.9772 3.31396 13.9324 4.09828 13.9324 5.06887C13.9324 6.03945 11.9772 6.82377 9.56997 6.82377C7.16276 6.82377 5.20752 6.03945 5.20752 5.06887"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.88623 5.06885V8.31395C1.88623 10.4316 5.3251 12.1473 9.57946 12.1473C13.8338 12.1473 17.2727 10.4316 17.2727 8.31395V5.06885"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.1233 10.6765C16.1233 12.7941 12.6844 14.5098 8.43005 14.5098C4.17568 14.5098 0.736816 12.7941 0.736816 10.6765C0.736816 9.97061 1.12 9.31374 1.78813 8.74512"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.736816 10.6763V13.9214C0.736816 16.039 4.17568 17.7547 8.43005 17.7547C12.6844 17.7547 16.1233 16.039 16.1233 13.9214V10.6763"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3698_2417">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  filter: ({width = 85, height = 85, ...rest}: LucideProps) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 85 85"
      fill="none"
      {...rest}>
      <path
        opacity="0.2"
        d="M45.72 64.8316H39.28L36.8125 54.3184H48.1875L45.72 64.8316Z"
        fill="currentColor"
      />
      <path
        opacity="0.2"
        d="M47.7325 54.3187H37.2675L15.83 36.8555H69.17L47.7325 54.3187Z"
        fill="currentColor"
      />
      <path
        d="M72.67 51.1788C72.67 51.1788 72.5825 51.1788 72.5475 51.1788C71.34 51.1082 70.43 50.0675 70.5 48.8503C70.535 48.3035 70.5525 47.7567 70.5525 47.2098C70.5525 45.9927 71.5325 45.0049 72.74 45.0049C73.9475 45.0049 74.9275 45.9927 74.9275 47.2098C74.9275 47.8449 74.91 48.4799 74.875 49.0973C74.805 50.2615 73.8425 51.1788 72.6875 51.1788H72.67Z"
        fill="currentColor"
      />
      <path
        d="M42.5 79.8782C41.87 79.8782 41.2575 79.8605 40.6275 79.8253C39.42 79.7547 38.4925 78.714 38.5625 77.4968C38.6325 76.2797 39.63 75.3624 40.8725 75.4153C41.9575 75.4859 43.06 75.4859 44.1275 75.4153C45.37 75.3624 46.3675 76.2797 46.4375 77.4792C46.5075 78.6963 45.58 79.737 44.39 79.8076C43.76 79.8429 43.13 79.8605 42.5 79.8605V79.8782ZM28.955 76.6501C28.6225 76.6501 28.29 76.5796 27.975 76.4208C26.8725 75.8563 25.77 75.2213 24.72 74.5334C23.705 73.8631 23.425 72.5048 24.09 71.4817C24.755 70.4586 26.12 70.1764 27.1175 70.8467C28.0275 71.4464 28.99 72.0109 29.9525 72.4872C31.0375 73.034 31.475 74.357 30.9325 75.4506C30.5475 76.2268 29.7775 76.6678 28.9725 76.6678L28.955 76.6501ZM56.08 76.6501C55.275 76.6501 54.505 76.2091 54.12 75.433C53.5775 74.3393 54.015 73.0163 55.0825 72.4695C56.045 71.9756 56.99 71.4288 57.9 70.829C58.915 70.1587 60.2625 70.441 60.9275 71.4641C61.5925 72.4872 61.3125 73.8454 60.2975 74.5157C59.2475 75.2037 58.1625 75.8563 57.0425 76.4208C56.7275 76.5796 56.395 76.6501 56.0625 76.6501H56.08ZM17.2825 66.1898C16.565 66.1898 15.8825 65.837 15.4625 65.202C14.78 64.1436 14.1325 63.0499 13.5725 61.921C13.03 60.8273 13.4675 59.5044 14.535 58.9575C15.62 58.4107 16.9325 58.8517 17.475 59.9277C17.965 60.8979 18.5075 61.8504 19.1025 62.7677C19.7675 63.7908 19.4875 65.1491 18.49 65.8194C18.1225 66.0663 17.7025 66.1898 17.2825 66.1898ZM67.7525 66.1722C67.3325 66.1722 66.93 66.0487 66.545 65.8017C65.53 65.1314 65.25 63.7732 65.915 62.7501C66.51 61.8328 67.0525 60.8803 67.5425 59.9101C68.085 58.8164 69.3975 58.3931 70.4825 58.9223C71.5675 59.4691 72.005 60.7921 71.4625 61.8857C70.9025 63.0147 70.2725 64.1083 69.5725 65.1667C69.1525 65.8017 68.4525 66.1545 67.7525 66.1545V66.1722Z"
        fill="currentColor"
      />
      <path
        d="M12.33 51.1788C11.175 51.1788 10.2125 50.2791 10.1425 49.0973C10.1075 48.4623 10.09 47.8449 10.09 47.2098C10.09 45.9927 11.07 45.0049 12.2775 45.0049C13.485 45.0049 14.465 45.9927 14.465 47.2098C14.465 47.7567 14.465 48.3035 14.5175 48.8503C14.5875 50.0675 13.66 51.1082 12.47 51.1788C12.435 51.1788 12.3825 51.1788 12.3475 51.1788H12.33Z"
        fill="currentColor"
      />
      <path
        d="M69.17 29.5879H15.83V36.8554H69.17V29.5879Z"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.7325 54.3187H37.2675L15.83 36.8555H69.17L47.7325 54.3187Z"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.72 64.8316H39.28L36.8125 54.3184H48.1875L45.72 64.8316Z"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.0875 23.9788C28.0257 23.9788 30.4075 21.578 30.4075 18.6164C30.4075 15.6548 28.0257 13.2539 25.0875 13.2539C22.1494 13.2539 19.7675 15.6548 19.7675 18.6164C19.7675 21.578 22.1494 23.9788 25.0875 23.9788Z"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.5 15.2287C44.665 15.2287 46.42 13.4597 46.42 11.2775C46.42 9.09522 44.665 7.32617 42.5 7.32617C40.3351 7.32617 38.58 9.09522 38.58 11.2775C38.58 13.4597 40.3351 15.2287 42.5 15.2287Z"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.35 29.588C46.35 24.6136 50.34 20.5918 55.275 20.5918C60.21 20.5918 64.2 24.6136 64.2 29.588"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  google: (props: LucideProps) => (
    <svg viewBox="0 0 32 32" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.4388 16.7516C28.4388 15.8675 28.3594 15.0173 28.2121 14.2012H16.4688V19.0243H23.1792C22.8902 20.5829 22.0117 21.9035 20.6911 22.7876V25.9162H24.7208C27.0786 23.7455 28.4388 20.5489 28.4388 16.7516Z"
        fill="#4285F4"
        // style="fill:#4285F4;fill:color(display-p3 0.2588 0.5216 0.9569);fill-opacity:1;"
        fillOpacity="1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4683 28.9376C19.8348 28.9376 22.6573 27.8211 24.7203 25.9168L20.6906 22.7882C19.5741 23.5364 18.1459 23.9784 16.4683 23.9784C13.2207 23.9784 10.4719 21.7851 9.4914 18.8379H5.32568V22.0684C7.37737 26.1435 11.5941 28.9376 16.4683 28.9376Z"
        fill="#34A853"
        // style="fill:#34A853;fill:color(display-p3 0.2039 0.6588 0.3255);fill-opacity:1;"
        fillOpacity="1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.49194 18.8378C9.24256 18.0897 9.10087 17.2906 9.10087 16.4688C9.10087 15.647 9.24256 14.8478 9.49194 14.0997V10.8691H5.32623C4.48175 12.5524 4 14.4568 4 16.4688C4 18.4808 4.48175 20.3851 5.32623 22.0684L9.49194 18.8378Z"
        fill="#FBBC05"
        // style="fill:#FBBC05;fill:color(display-p3 0.9843 0.7373 0.0196);fill-opacity:1;"
        fillOpacity="1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4683 8.95918C18.2989 8.95918 19.9425 9.58829 21.2347 10.8238L24.811 7.24755C22.6516 5.23554 19.8292 4 16.4683 4C11.5941 4 7.37737 6.79414 5.32568 10.8692L9.4914 14.0997C10.4719 11.1526 13.2207 8.95918 16.4683 8.95918Z"
        fill="#EA4335"
        // style="fill:#EA4335;fill:color(display-p3 0.9176 0.2627 0.2078);fill-opacity:1;"
        fillOpacity="1"
      />
    </svg>
  ),
  keplr: (props: LucideProps) => (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <g clipPath="url(#clip0_592_2954)">
        <mask
          id="mask0_592_2954"
          // style="mask-type:luminance"
          style={{maskType: 'luminance'}}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="24">
          <path
            d="M24 0H0V24H24V0Z"
            fill="white"
            // style="fill:white;fill:white;fill-opacity:1;"
            fillOpacity="1"
          />
        </mask>
        <g mask="url(#mask0_592_2954)">
          <path
            d="M18.5454 0H5.45454C2.44209 0 0 2.44209 0 5.45454V18.5454C0 21.5579 2.44209 24 5.45454 24H18.5454C21.5579 24 24 21.5579 24 18.5454V5.45454C24 2.44209 21.5579 0 18.5454 0Z"
            fill="url(#paint0_linear_592_2954)"
          />
          <path
            d="M18.5454 0H5.45454C2.44209 0 0 2.44209 0 5.45454V18.5454C0 21.5579 2.44209 24 5.45454 24H18.5454C21.5579 24 24 21.5579 24 18.5454V5.45454C24 2.44209 21.5579 0 18.5454 0Z"
            fill="url(#paint1_radial_592_2954)"
          />
          <path
            d="M18.5454 0H5.45454C2.44209 0 0 2.44209 0 5.45454V18.5454C0 21.5579 2.44209 24 5.45454 24H18.5454C21.5579 24 24 21.5579 24 18.5454V5.45454C24 2.44209 21.5579 0 18.5454 0Z"
            fill="url(#paint2_radial_592_2954)"
          />
          <path
            d="M18.5454 0H5.45454C2.44209 0 0 2.44209 0 5.45454V18.5454C0 21.5579 2.44209 24 5.45454 24H18.5454C21.5579 24 24 21.5579 24 18.5454V5.45454C24 2.44209 21.5579 0 18.5454 0Z"
            fill="url(#paint3_radial_592_2954)"
          />
          <path
            d="M9.85861 18.4347V12.8677L15.2677 18.4347H18.2771V18.2899L12.0551 11.9495L17.7982 5.93431V5.86328H14.7693L9.85861 11.1788V5.86328H7.41992V18.4347H9.85861Z"
            fill="white"
            // style="fill:white;fill:white;fill-opacity:1;"
            fillOpacity="1"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_592_2954"
          x1="12"
          y1="0"
          x2="12"
          y2="24"
          gradientUnits="userSpaceOnUse">
          <stop
            stopColor="#1FD1FF"
            // style="stopColor:#1FD1FF;stopColor:color(display-p3 0.1216 0.8196 1.0000);stopOpacity:1;"
            stopOpacity="1"
          />
          <stop
            offset="1"
            stopColor="#1BB8FF"
            // style="stopColor:#1BB8FF;stopColor:color(display-p3 0.1059 0.7216 1.0000);stopOpacity:1;"
            stopOpacity="1"
          />
        </linearGradient>
        <radialGradient
          id="paint1_radial_592_2954"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(1.14642 23.0906) rotate(-45.1556) scale(38.4884 39.0642)">
          <stop
            stopColor="#232DE3"
            // style="stopColor:#232DE3;stopColor:color(display-p3 0.1373 0.1765 0.8902);stopOpacity:1;"
            stopOpacity="1"
          />
          <stop
            offset="1"
            stopColor="#232DE3"
            stopOpacity="0"
            // style="stopColor:none;stopColor:none;stopOpacity:0;"
          />
        </radialGradient>
        <radialGradient
          id="paint2_radial_592_2954"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(22.7074 23.863) rotate(-138.45) scale(24.065 36.6923)">
          <stop
            stopColor="#8B4DFF"
            // style="stopColor:#8B4DFF;stopColor:color(display-p3 0.5451 0.3020 1.0000);stopOpacity:1;"
            stopOpacity="1"
          />
          <stop
            offset="1"
            stopColor="#8B4DFF"
            stopOpacity="0"
            // style="stopColor:none;stopColor:none;stopOpacity:0;"
          />
        </radialGradient>
        <radialGradient
          id="paint3_radial_592_2954"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.8001 0.177999) rotate(90) scale(18.922 45.9099)">
          <stop
            stopColor="#24D5FF"
            // style="stopColor:#24D5FF;stopColor:color(display-p3 0.1412 0.8353 1.0000);stopOpacity:1;"
            stopOpacity="1"
          />
          <stop
            offset="1"
            stopColor="#1BB8FF"
            stopOpacity="0"
            // style="stopColor:none;stopColor:none;stopOpacity:0;"
          />
        </radialGradient>
        <clipPath id="clip0_592_2954">
          <rect
            width="24"
            height="24"
            fill="white"
            // style="fill:white;fill:white;fill-opacity:1;"
            fillOpacity="1"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  leadger: (props: LucideProps) => (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <rect width="24" height="24" rx="5" fill="black" />
      <path
        d="M4 15.0247V19H10.0183V18.1184H4.87688V15.0247H4ZM19.1232 15.0247V18.1184H13.9817V18.9998H20V15.0247H19.1232ZM10.027 8.97526V15.0245H13.9817V14.2295H10.9039V8.97526H10.027ZM4 5V8.97526H4.87688V5.88139H10.0183V5H4ZM13.9817 5V5.88139H19.1232V8.97526H20V5H13.9817Z"
        fill="white"
      />
    </svg>
  ),
  leap: (props: LucideProps) => (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <mask
        id="mask0_592_2980"
        style={{maskType: 'luminance'}}
        maskUnits="userSpaceOnUse"
        x="0"
        y="4"
        width="24"
        height="15">
        <path
          d="M23.5393 4H0.460754V18.9931H23.5393V4Z"
          fill="white"
          // style="fill:white;fill:white;fill-opacity:1;"
          fillOpacity="1"
        />
      </mask>
      <g mask="url(#mask0_592_2980)">
        <path
          d="M21.2526 14.3509C21.2526 17.6516 17.2231 18.993 12.2166 18.993C7.21009 18.993 3.1225 17.6516 3.1225 14.3509C3.1225 11.0502 7.18369 8.37793 12.1849 8.37793C17.1914 8.37793 21.2526 11.0555 21.2526 14.3509Z"
          fill="#4BAF74"
          // style="fill:#4BAF74;fill:color(display-p3 0.2941 0.6863 0.4549);fill-opacity:1;"
          fillOpacity="1"
        />
      </g>
      <mask
        id="mask1_592_2980"
        style={{maskType: 'luminance'}}
        maskUnits="userSpaceOnUse"
        x="0"
        y="4"
        width="24"
        height="15">
        <path
          d="M23.5393 4H0.460754V18.9931H23.5393V4Z"
          fill="white"
          // style="fill:white;fill:white;fill-opacity:1;"
          fillOpacity="1"
        />
      </mask>
      <g mask="url(#mask1_592_2980)">
        <path
          d="M20.3285 7.15284C20.3285 5.41534 18.9079 4 17.1598 4C16.1723 4 15.2956 4.4489 14.7147 5.15129C13.9225 4.97701 13.0775 4.87667 12.2061 4.87667C11.3295 4.87667 10.4898 4.97173 9.69758 5.15129C9.11138 4.4489 8.22943 4 7.25242 4C5.50436 4 4.08374 5.41006 4.08374 7.15284C4.08374 7.7232 4.23689 8.25659 4.50095 8.71605C4.24746 9.25473 4.11543 9.82509 4.11543 10.4219C4.11543 13.4849 7.74357 15.967 12.2114 15.967C16.6792 15.967 20.3074 13.4849 20.3074 10.4219C20.3074 9.82509 20.1701 9.25473 19.9219 8.71605C20.1754 8.25659 20.3285 7.7232 20.3285 7.15284Z"
          fill="#32DA6D"
          // style="fill:#32DA6D;fill:color(display-p3 0.1961 0.8549 0.4275);fill-opacity:1;"
          fillOpacity="1"
        />
      </g>
      <mask
        id="mask2_592_2980"
        style={{maskType: 'luminance'}}
        maskUnits="userSpaceOnUse"
        x="0"
        y="4"
        width="24"
        height="15">
        <path
          d="M23.5393 4H0.460754V18.9931H23.5393V4Z"
          fill="white"
          // style="fill:white;fill:white;fill-opacity:1;"
          fillOpacity="1"
        />
      </mask>
      <g mask="url(#mask2_592_2980)">
        <path
          d="M6.99353 8.90112C8.06032 8.90112 8.93171 8.0403 8.93171 6.97351C8.93171 5.912 8.0656 5.0459 6.99353 5.0459C5.92674 5.0459 5.05536 5.90672 5.05536 6.97351C5.06064 8.0403 5.92674 8.90112 6.99353 8.90112Z"
          fill="#F1F1E8"
          // style="fill:#F1F1E8;fill:color(display-p3 0.9451 0.9451 0.9098);fill-opacity:1;"
          fillOpacity="1"
        />
      </g>
      <mask
        id="mask3_592_2980"
        style={{maskType: 'luminance'}}
        maskUnits="userSpaceOnUse"
        x="0"
        y="4"
        width="24"
        height="15">
        <path
          d="M23.5393 4H0.460754V18.9931H23.5393V4Z"
          fill="white"
          // style="fill:white;fill:white;fill-opacity:1;"
          fillOpacity="1"
        />
      </mask>
      <g mask="url(#mask3_592_2980)">
        <path
          d="M17.3236 8.90112C18.3903 8.90112 19.2617 8.0403 19.2617 6.97351C19.2617 5.912 18.3956 5.0459 17.3236 5.0459C16.2515 5.0459 15.3854 5.90672 15.3854 6.97351C15.3854 8.0403 16.2515 8.90112 17.3236 8.90112Z"
          fill="#F1F1E8"
          // style="fill:#F1F1E8;fill:color(display-p3 0.9451 0.9451 0.9098);fill-opacity:1;"
          fillOpacity="1"
        />
      </g>
      <mask
        id="mask4_592_2980"
        style={{maskType: 'luminance'}}
        maskUnits="userSpaceOnUse"
        x="0"
        y="4"
        width="24"
        height="15">
        <path
          d="M23.5393 4H0.460754V18.9931H23.5393V4Z"
          fill="white"
          // style="fill:white;fill:white;fill-opacity:1;"
          fillOpacity="1"
        />
      </mask>
      <g mask="url(#mask4_592_2980)">
        <path
          d="M5.96374 18.7655C6.38094 18.7655 6.70838 18.4064 6.66085 17.9944C6.49185 16.5474 5.76833 13.4157 2.59437 11.5303C-1.63053 9.02179 1.71242 17.6564 1.71242 17.6564L0.835757 18.1581C0.540013 18.3271 0.66676 18.7655 0.999471 18.7655H5.96374Z"
          fill="#32DA6D"
          // style="fill:#32DA6D;fill:color(display-p3 0.1961 0.8549 0.4275);fill-opacity:1;"
          fillOpacity="1"
        />
      </g>
      <mask
        id="mask5_592_2980"
        style={{maskType: 'luminance'}}
        maskUnits="userSpaceOnUse"
        x="0"
        y="4"
        width="24"
        height="15">
        <path
          d="M23.5393 4H0.460754V18.9931H23.5393V4Z"
          fill="white"
          // style="fill:white;fill:white;fill-opacity:1;"
          fillOpacity="1"
        />
      </mask>
      <g mask="url(#mask5_592_2980)">
        <path
          d="M18.5699 18.7655C18.195 18.7655 17.8992 18.4064 17.9415 17.9944C18.0893 16.5527 18.7442 13.4157 21.6066 11.5303C25.4248 9.02179 22.404 17.6564 22.404 17.6564L23.1962 18.1581C23.4602 18.3271 23.3493 18.7655 23.0483 18.7655H18.5699Z"
          fill="#32DA6D"
          // style="fill:#32DA6D;fill:color(display-p3 0.1961 0.8549 0.4275);fill-opacity:1;"
          fillOpacity="1"
        />
      </g>
      <mask
        id="mask6_592_2980"
        // style="mask-type:luminance"
        style={{maskType: 'luminance'}}
        maskUnits="userSpaceOnUse"
        x="0"
        y="4"
        width="24"
        height="15">
        <path
          d="M23.5393 4H0.460754V18.9931H23.5393V4Z"
          fill="white"
          // style="fill:white;fill:white;fill-opacity:1;"
          fillOpacity="1"
        />
      </mask>
      <g mask="url(#mask6_592_2980)">
        <path
          d="M6.99361 7.32699C7.18901 7.32699 7.34744 7.16856 7.34744 6.97844C7.34744 6.78304 7.18901 6.62988 6.99361 6.62988C6.7982 6.62988 6.63977 6.78832 6.63977 6.97844C6.64505 7.16856 6.80348 7.32699 6.99361 7.32699Z"
          fill="#0D0D0D"
          // style="fill:#0D0D0D;fill:color(display-p3 0.0510 0.0510 0.0510);fill-opacity:1;"
          fillOpacity="1"
        />
      </g>
      <mask
        id="mask7_592_2980"
        // style="mask-type:luminance"
        style={{maskType: 'luminance'}}
        maskUnits="userSpaceOnUse"
        x="0"
        y="4"
        width="24"
        height="15">
        <path
          d="M23.5393 4H0.460754V18.9931H23.5393V4Z"
          fill="white"
          // style="fill:white;fill:white;fill-opacity:1;"
          fillOpacity="1"
        />
      </mask>
      <g mask="url(#mask7_592_2980)">
        <path
          d="M17.3234 7.32699C17.5188 7.32699 17.6773 7.16856 17.6773 6.97844C17.6773 6.78304 17.5188 6.62988 17.3234 6.62988C17.128 6.62988 16.9696 6.78832 16.9696 6.97844C16.9696 7.16856 17.128 7.32699 17.3234 7.32699Z"
          fill="#0D0D0D"
          // style="fill:#0D0D0D;fill:color(display-p3 0.0510 0.0510 0.0510);fill-opacity:1;"
          fillOpacity="1"
        />
      </g>
    </svg>
  ),
  leverage: (props: LucideProps) => (
    <svg viewBox="0 0 21 21" fill="none" {...props}>
      <path
        d="M13.7439 19.6018L10.8042 14.8154L7.8833 19.6018H13.7439Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.55176 17.5101L19.4161 10.5566"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.08057 11.1031L3.13459 13.1759L5.16977 11.1031"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.7964 7.52266C18.4824 7.52266 19.8492 6.15588 19.8492 4.46988C19.8492 2.78389 18.4824 1.41711 16.7964 1.41711C15.1104 1.41711 13.7437 2.78389 13.7437 4.46988C13.7437 6.15588 15.1104 7.52266 16.7964 7.52266Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  liquidityMining: (props: LucideProps) => (
    <svg viewBox="0 0 16 17" fill="none" {...props}>
      <path
        d="M10.9 15.4893H1.21997V7.0293L4.90997 8.5593L6.28997 11.0193L8.78997 11.7793L10.9 15.4893Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.46997 10.0098L2.65997 10.8798H1.21997"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.63989 13.1504L5.39989 14.0304V15.4904"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9099 1.09961L7.16992 6.21961L8.83992 2.33961L12.9099 1.10961V1.09961Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7799 8.76937L11.1399 5.10938"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.19995 4.75L4.63995 5.72"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.63 8.24023L8.5 8.59023"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.41 10.8791L11.26 10.8691"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  lines: ({width = 22, height = 12, ...rest}: LucideProps) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 12"
      fill="none"
      {...rest}>
      <path
        d="M1.33333 0.666748C0.596954 0.666748 0 1.2637 0 2.00008C0 2.73646 0.596954 3.33341 1.33333 3.33341H20C20.7364 3.33341 21.3333 2.73646 21.3333 2.00008C21.3333 1.2637 20.7364 0.666748 20 0.666748H1.33333Z"
        fill="currentColor"
      />
      <path
        d="M1.33333 8.66675C0.596954 8.66675 0 9.2637 0 10.0001C0 10.7365 0.596954 11.3334 1.33333 11.3334H20C20.7364 11.3334 21.3333 10.7365 21.3333 10.0001C21.3333 9.2637 20.7364 8.66675 20 8.66675H1.33333Z"
        fill="currentColor"
      />
    </svg>
  ),
  logo: (props: LucideProps) => (
    <svg viewBox="0 0 88 40" fill="none" {...props}>
      <path
        d="M7.03575 23.5293C5.75039 22.2482 5.04495 20.5435 5.04495 18.7252C5.04495 17.4784 5.37873 16.2631 6.01405 15.2099C6.30156 14.7414 6.64516 14.3046 7.03575 13.9126L9.89609 11.0516C10.8042 10.1428 11.3147 8.91068 11.3147 7.62672V2.5L3.66071 10.1568C1.29264 12.5241 -0.0411078 15.7056 0.000966226 18.8864C0.0444428 21.9901 1.27441 24.9072 3.46717 27.0986L13.87 37.5V32.3354C13.87 31.0753 13.37 29.8671 12.4794 28.9758L7.03575 23.5293Z"
        fill="currentColor"
      />
      <path
        d="M21.192 10.1667L13.5339 2.50854V7.63036C13.5339 8.91572 14.0451 10.1492 14.9546 11.0573L17.81 13.9106C19.0954 15.1974 19.8022 16.9042 19.8022 18.7232C19.8022 19.9749 19.467 21.1887 18.8331 22.2343C18.8107 22.27 18.7882 22.3058 18.7658 22.3402L10.2002 13.7746V18.9854C10.2002 20.2154 10.689 21.3956 11.5585 22.2651L15.3192 26.0258L18.8822 29.5888L20.9536 27.5174C20.9536 27.5174 20.9578 27.5132 20.9599 27.5118L21.3744 27.0973C21.7397 26.7292 22.0812 26.347 22.3827 25.9564C22.4395 25.8849 22.4935 25.8134 22.5468 25.7418C24.0888 23.648 24.8812 21.1558 24.8434 18.5381C24.7971 15.4477 23.4998 12.4738 21.192 10.1653V10.1667Z"
        fill="currentColor"
      />
      <path
        d="M39.9977 9.90417C35.483 9.93013 32.3088 13.0459 32.3088 17.6488C32.3088 22.2517 35.3974 25.3377 40.082 25.3377C42.7138 25.3377 44.8835 24.3929 46.3707 22.7656L44.6279 20.9086C43.5131 22.0493 41.9961 22.68 40.339 22.68C37.9395 22.68 36.1383 21.2227 35.6245 18.8777H47.1116C47.5139 13.3898 45.3403 9.90417 39.9951 9.90417H39.9977ZM35.5686 16.4744C35.9411 14.0451 37.6281 12.532 40.0275 12.532C42.427 12.532 44.1425 14.0192 44.258 16.4744H35.5686Z"
        fill="currentColor"
      />
      <path
        d="M53.9771 4.02173H50.6887V25.2273H53.9771V4.02173Z"
        fill="currentColor"
      />
      <path
        d="M84.1291 20.8232C84.1551 15.308 76.0678 16.8225 76.0678 14.0233C76.0678 12.9346 77.0125 12.5063 78.2973 12.5063C79.582 12.5063 81.3274 13.0228 82.6705 13.8494L83.8709 11.4202C82.4979 10.4495 80.4709 9.8772 78.5555 9.8772C75.6396 9.8772 72.9521 11.1918 72.9521 14.2777C72.9222 19.7656 80.9251 18.0241 80.9251 21.1386C80.9251 22.2793 79.8402 22.7672 78.44 22.7672C76.7829 22.7672 74.6676 22.0509 73.353 20.8816L72.1799 23.2253C73.6969 24.5956 76.0665 25.3405 78.296 25.3405C81.3559 25.3405 84.1278 23.939 84.1278 20.8232H84.1291Z"
        fill="currentColor"
      />
      <path
        d="M37.6187 34.7378L34.8429 31.0757H34.1331V35.9044H34.8429V32.2423L37.6187 35.9044H38.3298V31.0757H37.6187V34.7378Z"
        fill="currentColor"
      />
      <path
        d="M41.5765 35.9044H45.1257V35.2439H42.2929V33.7749H44.8519V33.1144H42.2929V31.7362H45.1257V31.0757H41.5765V35.9044Z"
        fill="currentColor"
      />
      <path
        d="M47.8889 31.7362H49.4708V35.9044H50.1806V31.7362H51.769V31.0757H47.8889V31.7362Z"
        fill="currentColor"
      />
      <path
        d="M59.5587 34.7585L58.3492 31.0757H57.5615L56.3534 34.7585L55.1647 31.0757H54.3783L55.9667 35.9044H56.6765L57.9625 32.0593L59.2343 35.9044H59.9454L61.5338 31.0757H60.7461L59.5587 34.7585Z"
        fill="currentColor"
      />
      <path
        d="M66.7053 30.9807C65.3479 30.9807 64.1956 32.1201 64.1956 33.4762C64.1956 34.8323 65.3479 35.9781 66.7053 35.9781C68.0627 35.9781 69.2008 34.8323 69.2008 33.4762C69.2008 32.1201 68.0614 30.9807 66.7053 30.9807ZM66.7053 35.3254C65.7424 35.3254 64.9262 34.4819 64.9262 33.4762C64.9262 32.4705 65.7411 31.6348 66.7053 31.6348C67.6695 31.6348 68.4766 32.4783 68.4766 33.4762C68.4766 34.4741 67.6682 35.3254 66.7053 35.3254Z"
        fill="currentColor"
      />
      <path
        d="M76.0053 32.6498C76.0053 31.7284 75.2319 31.0757 74.2132 31.0757H72.181V35.9044H72.8909V34.2239H74.0017L75.1826 35.9044H75.9975L74.7673 34.1538C75.4979 33.9644 76.004 33.3947 76.004 32.6498H76.0053ZM74.1146 33.5634H72.8909V31.7362H74.1146C74.8102 31.7362 75.2812 32.0801 75.2812 32.6498C75.2812 33.2195 74.8102 33.5634 74.1146 33.5634Z"
        fill="currentColor"
      />
      <path
        d="M82.8946 31.0757H81.9875L79.7101 33.5919V31.0757H79.0002V35.9044H79.7101V34.4925L80.4134 33.7398L82.1355 35.9044H83.0283L80.9117 33.248L82.8946 31.0757Z"
        fill="currentColor"
      />
      <path
        d="M61.6393 21.7031C61.8677 21.4876 62.0676 21.2086 62.2337 20.8777C62.3972 20.5507 62.5218 20.1913 62.6022 19.8084C62.6827 19.4269 62.719 19.0194 62.7087 18.5977C62.6983 18.1733 62.6308 17.7529 62.5088 17.3454C62.1117 16.0594 61.9404 15.6896 61.398 14.3789C60.8555 13.0708 60.3222 11.7523 59.8096 10.4585L59.7733 10.3651H56.0891L61.4888 21.8419L61.6381 21.7018L61.6393 21.7031Z"
        fill="currentColor"
      />
      <path
        d="M63.4876 21.864C63.1905 22.5777 62.9063 23.2318 62.6428 23.8092C62.3794 24.3867 62.0991 24.8902 61.8097 25.3081C61.5255 25.7168 61.1959 26.04 60.8286 26.2658C60.0955 26.7174 58.9742 26.6655 57.7155 26.3903L57.6 26.3657L56.676 28.3667L56.8447 28.4122C57.7336 28.6496 59.0054 28.7885 59.8774 28.8209C60.8455 28.8209 61.6657 28.66 62.3171 28.3421C62.966 28.0254 63.5408 27.5816 64.0262 27.0223C64.505 26.4708 64.9423 25.809 65.3239 25.055C65.7054 24.2972 66.1064 23.4718 66.5164 22.5959L71.4996 10.3651H68.0672L63.4876 21.8666V21.864Z"
        fill="currentColor"
      />
    </svg>
  ),
  logoTestnet: (props: LucideProps) => (
    <svg viewBox="0 0 86 42" fill="none" {...props}>
      <g clipPath="url(#clip0_3698_2436)">
        <g clipPath="url(#clip1_3698_2436)">
          <path
            d="M7.0355 24.5293C5.75014 23.2482 5.0447 21.5435 5.0447 19.7252C5.0447 18.4784 5.37849 17.2631 6.0138 16.2099C6.30131 15.7414 6.64491 15.3046 7.0355 14.9126L9.89584 12.0516C10.8039 11.1428 11.3144 9.91068 11.3144 8.62672V3.5L3.66046 11.1568C1.2931 13.5241 -0.0413525 16.7056 0.000721599 19.8864C0.0441981 22.9901 1.27416 25.9072 3.46692 28.0986L13.8697 38.5V33.3354C13.8697 32.0753 13.3698 30.8671 12.4792 29.9758L7.0355 24.5293Z"
            fill="white"
          />
          <path
            d="M21.192 11.1689L13.5339 3.51074V8.63256C13.5339 9.91792 14.0451 11.1514 14.9546 12.0595L17.81 14.9128C19.0953 16.1996 19.8022 17.9064 19.8022 19.7254C19.8022 20.9771 19.467 22.1909 18.8331 23.2365C18.8106 23.2722 18.7882 23.308 18.7658 23.3423L10.2002 14.7768V19.9876C10.2002 21.2176 10.689 22.3978 11.5585 23.2673L15.3192 27.028L18.8822 30.591L20.9536 28.5196C20.9536 28.5196 20.9578 28.5154 20.9599 28.5139L21.3744 28.0995C21.7397 27.7314 22.0812 27.3492 22.3827 26.9586C22.4395 26.8871 22.4935 26.8156 22.5468 26.744C24.0888 24.6501 24.8812 22.158 24.8434 19.5403C24.7971 16.4499 23.4998 13.476 21.192 11.1675V11.1689Z"
            fill="white"
          />
          <path
            d="M37.9592 10.1953C33.127 10.2234 29.7295 13.5584 29.7295 18.4846C29.7295 23.4108 33.0358 26.7143 38.0503 26.7143C40.8665 26.7143 43.1904 25.7031 44.7822 23.9605L42.9169 21.9732C41.7234 23.1948 40.1007 23.8694 38.3266 23.8694C35.758 23.8694 33.8303 22.3091 33.2805 19.8001H45.576C46.0058 13.9252 43.6798 10.1953 37.9585 10.1953H37.9592ZM33.2181 17.2287C33.6171 14.6292 35.4221 13.0087 37.9907 13.0087C40.5594 13.0087 42.3959 14.6005 42.5186 17.2287H33.2181Z"
            fill="white"
          />
          <path
            d="M52.9201 3.89404H49.4006V26.5923H52.9201V3.89404Z"
            fill="white"
          />
          <path
            d="M85.1958 21.8794C85.2239 15.9764 76.5671 17.5962 76.5671 14.6013C76.5671 13.4365 77.5783 12.9779 78.9534 12.9779C80.3285 12.9779 82.1966 13.5305 83.6349 14.4161L84.9188 11.816C83.449 10.7767 81.2794 10.1646 79.229 10.1646C76.1078 10.1646 73.2321 11.5712 73.2321 14.874C73.2005 20.749 81.7661 18.8837 81.7661 22.2181C81.7661 23.4396 80.6041 23.9606 79.1063 23.9606C77.3322 23.9606 75.0686 23.1942 73.6619 21.9418L72.406 24.4508C74.0294 25.9171 76.5664 26.7144 78.9527 26.7144C82.2275 26.7144 85.1951 25.2137 85.1951 21.8787L85.1958 21.8794Z"
            fill="white"
          />
          <path
            d="M35.4131 36.7666L32.4413 32.8467H31.6812V38.0162H32.4413V34.0956L35.4131 38.0162H36.1733V32.8467H35.4131V36.7666Z"
            fill="white"
          />
          <path
            d="M39.6484 38.0162H43.4484V37.3086H40.4163V35.7358H43.1553V35.0289H40.4163V33.5542H43.4484V32.8467H39.6484V38.0162Z"
            fill="white"
          />
          <path
            d="M46.4048 33.5542H48.0983V38.0162H48.8577V33.5542H50.5582V32.8467H46.4048V33.5542Z"
            fill="white"
          />
          <path
            d="M58.8952 36.7897L57.6007 32.8467H56.7579L55.4641 36.7897L54.192 32.8467H53.3499L55.0503 38.0162H55.8098L57.187 33.8999L58.5488 38.0162H59.3089L61.0094 32.8467H60.1666L58.8952 36.7897Z"
            fill="white"
          />
          <path
            d="M66.5465 32.7563C65.0943 32.7563 63.8601 33.9751 63.8601 35.4273C63.8601 36.8796 65.0943 38.1061 66.5465 38.1061C67.9988 38.1061 69.2175 36.8796 69.2175 35.4273C69.2175 33.9751 67.9988 32.7563 66.5465 32.7563ZM66.5465 37.4062C65.5157 37.4062 64.6427 36.503 64.6427 35.4273C64.6427 34.3517 65.5157 33.4562 66.5465 33.4562C67.5773 33.4562 68.4427 34.3594 68.4427 35.4273C68.4427 36.4953 67.5773 37.4062 66.5465 37.4062Z"
            fill="white"
          />
          <path
            d="M76.5003 34.5324C76.5003 33.5465 75.6729 32.8467 74.5818 32.8467H72.4072V38.0155H73.1674V36.2175H74.3567L75.6203 38.0155H76.4933L75.1764 36.1418C75.959 35.9384 76.5003 35.329 76.5003 34.5317V34.5324ZM74.4766 35.5107H73.1674V33.5542H74.4766C75.2213 33.5542 75.7255 33.9231 75.7255 34.5324C75.7255 35.1418 75.2213 35.5107 74.4766 35.5107Z"
            fill="white"
          />
          <path
            d="M83.8739 32.8467H82.9034L80.4659 35.5408V32.8467H79.7058V38.0162H80.4659V36.5036L81.2184 35.6986L83.0612 38.0162H84.017L81.752 35.172L83.8739 32.8467Z"
            fill="white"
          />
          <path
            d="M61.1216 22.8192C61.3663 22.5878 61.5802 22.2905 61.7583 21.9357C61.9329 21.5857 62.0661 21.2008 62.1531 20.7912C62.2401 20.3831 62.2779 19.947 62.2674 19.4954C62.2562 19.0417 62.1847 18.5908 62.0535 18.1553C61.6286 16.7795 61.4448 16.3833 60.8649 14.9808C60.285 13.5805 59.7128 12.1689 59.1651 10.7846L59.1259 10.6851H55.1821L60.9624 22.97L61.1216 22.8192Z"
            fill="white"
          />
          <path
            d="M63.102 22.9952C62.7836 23.7589 62.48 24.4594 62.1981 25.0772C61.9162 25.695 61.6161 26.2349 61.3061 26.6816C61.0018 27.1199 60.6484 27.4642 60.2564 27.7061C59.4717 28.19 58.2719 28.1339 56.9241 27.8394L56.8007 27.8127L55.8113 29.9543L55.9915 30.0027C56.9431 30.2565 58.3049 30.4059 59.2375 30.4402C60.2732 30.4402 61.1519 30.2677 61.8489 29.9276C62.5431 29.5889 63.1588 29.1135 63.6784 28.5153C64.1917 27.9249 64.6587 27.2167 65.0669 26.4095C65.4757 25.5989 65.9041 24.7154 66.3431 23.7771L71.6774 10.6851H68.0029L63.1013 22.9959L63.102 22.9952Z"
            fill="white"
          />
          <path
            d="M64.5478 4.35888V3.90869H66.9131V4.35888H65.9966V6.87351H65.4636V4.35888H64.5471H64.5478Z"
            fill="white"
          />
          <path
            d="M67.7749 6.87281V3.90869H69.7033V4.35888H68.312V5.1639H69.603V5.61409H68.312V6.42332H69.7145V6.87351H67.7749V6.87281Z"
            fill="white"
          />
          <path
            d="M72.2707 4.72355C72.2573 4.59732 72.2005 4.49845 72.1003 4.42833C72.0007 4.3582 71.871 4.32244 71.7118 4.32244C71.5996 4.32244 71.5035 4.33927 71.4236 4.37293C71.3436 4.40659 71.2819 4.45287 71.2398 4.51037C71.1978 4.56787 71.1753 4.63449 71.1746 4.70882C71.1746 4.77053 71.1887 4.82382 71.2174 4.8694C71.2462 4.91498 71.2847 4.95285 71.3338 4.9844C71.3829 5.01596 71.4376 5.04191 71.4972 5.06294C71.5568 5.08398 71.6171 5.10221 71.6781 5.11624L71.9558 5.18566C72.068 5.2116 72.1753 5.24667 72.2791 5.29154C72.3829 5.33572 72.4761 5.39182 72.5582 5.45914C72.6409 5.52646 72.7061 5.6085 72.7545 5.70387C72.8029 5.79924 72.8267 5.91144 72.8267 6.03976C72.8267 6.21367 72.7826 6.36654 72.6935 6.49767C72.6045 6.6295 72.4768 6.73188 72.3092 6.80621C72.1416 6.87984 71.9397 6.91701 71.702 6.91701C71.4642 6.91701 71.2714 6.88124 71.1017 6.80972C70.932 6.73819 70.8002 6.63441 70.7048 6.49697C70.6094 6.36023 70.5583 6.19333 70.5505 5.99628H71.0786C71.0863 6.09937 71.1178 6.18562 71.1739 6.25364C71.23 6.32236 71.303 6.37355 71.3934 6.40721C71.4839 6.44087 71.5849 6.4577 71.6964 6.4577C71.8078 6.4577 71.9158 6.44017 72.0042 6.4051C72.0925 6.37004 72.162 6.32096 72.2118 6.25714C72.2622 6.19403 72.2875 6.1197 72.2882 6.03485C72.2875 5.95772 72.2644 5.8939 72.2202 5.84271C72.176 5.79223 72.1136 5.74945 72.0343 5.71509C71.9544 5.68073 71.8618 5.64988 71.756 5.62323L71.4187 5.53628C71.1746 5.47387 70.9818 5.3785 70.8401 5.25017C70.6985 5.12255 70.6284 4.95215 70.6284 4.73967C70.6284 4.56507 70.6761 4.4122 70.7707 4.28107C70.8661 4.14994 70.9951 4.04756 71.1592 3.97463C71.3233 3.9017 71.5091 3.86523 71.7167 3.86523C71.9243 3.86523 72.1115 3.9017 72.2707 3.97463C72.4298 4.04756 72.554 4.14853 72.6451 4.27686C72.7356 4.40589 72.7826 4.55385 72.7854 4.72074H72.2686L72.2707 4.72355Z"
            fill="white"
          />
          <path
            d="M73.5832 4.35888V3.90869H75.9485V4.35888H75.032V6.87351H74.499V4.35888H73.5825H73.5832Z"
            fill="white"
          />
          <path
            d="M79.2471 3.90869V6.87351H78.7696L77.3727 4.85396H77.3482V6.87351H76.811V3.90869H77.2914L78.6868 5.92965H78.7128V3.90869H79.2471Z"
            fill="white"
          />
          <path
            d="M80.238 6.87281V3.90869H82.1664V4.35888H80.7752V5.1639H82.0662V5.61409H80.7752V6.42332H82.1777V6.87351H80.238V6.87281Z"
            fill="white"
          />
          <path
            d="M82.9917 4.35888V3.90869H85.3569V4.35888H84.4404V6.87351H83.9075V4.35888H82.991H82.9917Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3698_2436">
          <rect
            width="85.357"
            height="41"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
        <clipPath id="clip1_3698_2436">
          <rect
            width="85.357"
            height="35"
            fill="white"
            transform="translate(0 3.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  metamask: (props: LucideProps) => (
    <svg viewBox="0 0 20 18" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5898 16.1259L11.0958 16.7877V15.9223L10.8922 15.7188H9.46705V16.7367V17.4493H10.994L12.8773 16.6349L13.5898 16.1259Z"
        fill="#CDBDB2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.44629 16.1259L7.8894 16.7877V15.9223L8.09299 15.7188H9.51813V16.7367V17.4493H7.99119L6.10801 16.6349L5.44629 16.1259Z"
        fill="#CDBDB2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8921 14.2428L11.0957 15.9224L10.8413 15.7188H8.19456L7.88917 15.9224L8.09276 14.2428L8.49995 13.9883L10.5359 14.0392L10.8921 14.2428Z"
        fill="#393939"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2666 2.89258L11.045 5.74287L10.4851 14.0393H8.50014L7.88937 5.74287L6.76961 2.89258H12.2666Z"
        fill="#F89C35"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.611 9.15292L19.0361 13.2756L15.4733 13.072H13.1829V11.2906L13.2847 7.62598L13.7937 8.03316L17.611 9.15292Z"
        fill="#F89D35"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9131 9.61035L10.7394 9.71215L11.1975 11.8499L13.1826 11.3409L14.9131 9.61035Z"
        fill="#D87C30"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9131 9.66211L13.1826 11.2908V12.9196L14.9131 9.66211Z"
        fill="#EA8D3A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1826 11.3408L11.1467 11.8498L10.485 14.0385L10.9431 14.2929L13.1826 12.9696V11.3408Z"
        fill="#F89D35"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1827 12.9697L13.5898 16.1254L10.8922 14.2422L13.1827 12.9697Z"
        fill="#EB8F35"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.74 9.71289L10.4855 14.0393L11.249 11.8252L10.74 9.71289Z"
        fill="#EA8E3A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5244 13.0207L13.1831 12.9697L13.5903 16.1254L15.5244 13.0207Z"
        fill="#D87C30"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9164 17.4995L13.5901 16.1252L15.5242 13.0205L19.0361 13.275L17.9164 17.4995Z"
        fill="#EB8F35"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0448 5.74219L13.2334 7.57452L14.9131 9.61044L10.7394 9.76318L11.0448 5.74219Z"
        fill="#E8821E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5898 16.1254L10.8922 14.2422L11.0958 15.8709V16.7871L12.9281 16.4308L13.5898 16.1254Z"
        fill="#DFCEC3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.44629 16.1254L8.09299 14.2422L7.8894 15.8709V16.7871L6.05707 16.4308L5.44629 16.1254Z"
        fill="#DFCEC3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8597 10.6289L11.2998 11.7996L13.2849 11.2906L11.8597 10.6289Z"
        fill="#393939"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9678 0.5L11.0456 5.74246L12.2162 2.89216L17.9678 0.5Z"
        fill="#E88F35"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9676 0.5L18.8838 3.29939L18.3748 6.35328L18.7311 6.55687L18.2221 7.01495L18.6293 7.37124L18.0694 7.88022L18.4257 8.18561L17.6113 9.20357L13.794 8.03291C11.9277 6.5399 11.0116 5.77643 11.0455 5.7425C11.0794 5.70857 13.3868 3.96107 17.9676 0.5Z"
        fill="#8E5A30"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.42515 9.15292L0 13.2756L3.56286 13.072H5.85323V11.2906L5.75144 7.62598L5.24246 8.03316L1.42515 9.15292Z"
        fill="#F89D35"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.12305 9.61035L8.29669 9.71215L7.83865 11.8499L5.85358 11.3409L4.12305 9.61035Z"
        fill="#D87C30"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.12305 9.66211L5.85358 11.2908V12.9196L4.12305 9.66211Z"
        fill="#EA8D3A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.85352 11.3408L7.88944 11.8498L8.55116 14.0385L8.09303 14.2929L5.85352 12.9696V11.3408Z"
        fill="#F89D35"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.85347 12.9697L5.44629 16.1254L8.09299 14.2931L5.85347 12.9697Z"
        fill="#EB8F35"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.29707 9.71289L8.5516 14.0393L7.78809 11.8252L8.29707 9.71289Z"
        fill="#EA8E3A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5127 13.0207L5.85401 12.9697L5.44682 16.1254L3.5127 13.0207Z"
        fill="#D87C30"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.11976 17.4995L5.44605 16.1252L3.51192 13.0205L0 13.275L1.11976 17.4995Z"
        fill="#EB8F35"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.9913 5.74219L5.80273 7.57452L4.12305 9.61044L8.29669 9.76318L7.9913 5.74219Z"
        fill="#E8821E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.17738 10.6289L7.7373 11.7996L5.75223 11.2906L7.17738 10.6289Z"
        fill="#393939"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.06934 0.5L7.99147 5.74246L6.82086 2.89216L1.06934 0.5Z"
        fill="#E88F35"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.06949 0.5L0.15332 3.29939L0.662301 6.35328L0.306015 6.55687L0.814995 7.01495L0.407811 7.37124L0.967689 7.88022L0.611403 8.18561L1.42577 9.20357L5.24313 8.03291C7.10939 6.5399 8.02556 5.77643 7.99162 5.7425C7.95769 5.70857 5.65031 3.96107 1.06949 0.5Z"
        fill="#8E5A30"
      />
    </svg>
  ),
  metamask2: (props: LucideProps) => (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <g clipPath="url(#clip0_883_98)">
        <path
          d="M22.1707 12.0228L23.2495 10.7564L22.7805 10.4124L23.5309 9.72443L22.9524 9.28664L23.7029 8.72378L23.2182 8.34853L24 4.53355L22.8117 1M22.8117 1L15.1818 3.82997H8.81824L1.18827 1L0 4.53355L0.797394 8.34853L0.297068 8.72378L1.06319 9.28664L0.484691 9.72443L1.23518 10.4124L0.766124 10.7564L1.84495 12.0228L0.203257 17.0886L1.71987 22.2638L7.05147 20.7941L8.08339 21.6384L10.1941 23.0769H13.8059L15.9166 21.6384L16.9485 20.7941L22.2958 22.2638L23.828 17.0886L22.1707 12.0228"
          fill="#F5841F"
        />
        <path
          d="M22.8118 1L13.4463 7.89511L15.1818 3.82997L22.8118 1Z"
          fill="#E27625"
        />
        <path
          d="M1.18848 1L10.4758 7.95765L8.81844 3.82997L1.18848 1Z"
          fill="#E27625"
        />
        <path
          d="M19.4499 16.9941L16.9482 20.7779L22.2955 22.2476L23.8277 17.0723L19.4499 16.9941Z"
          fill="#E27625"
        />
        <path
          d="M0.203125 17.0723L1.71974 22.2476L7.05133 20.7779L4.56534 16.9941L0.203125 17.0723Z"
          fill="#E27625"
        />
        <path
          d="M6.76952 10.5841L5.28418 12.8199L10.5689 13.0545L10.3969 7.39453L6.76952 10.5841Z"
          fill="#E27625"
        />
        <path
          d="M17.2456 10.5841L13.5557 7.33203L13.4463 13.0545L18.731 12.82L17.2456 10.5841Z"
          fill="#E27625"
        />
        <path
          d="M7.05176 20.7778L10.257 19.2455L7.48954 17.1191L7.05176 20.7778Z"
          fill="#E27625"
        />
        <path
          d="M13.7588 19.2455L16.9484 20.7778L16.5106 17.1191L13.7588 19.2455Z"
          fill="#E27625"
        />
        <path
          d="M16.9484 20.7783L13.7588 19.2461L14.0246 21.3099L13.9933 22.1855L16.9484 20.7783Z"
          fill="#D7C1B3"
        />
        <path
          d="M7.05176 20.7783L10.0224 22.1855L10.0068 21.3099L10.257 19.2461L7.05176 20.7783Z"
          fill="#D7C1B3"
        />
        <path
          d="M10.0691 15.7432L7.42676 14.9771L9.30298 14.1172L10.0691 15.7432Z"
          fill="#2F343B"
        />
        <path
          d="M13.9307 15.7432L14.7124 14.1172L16.5886 14.9771L13.9307 15.7432Z"
          fill="#2F343B"
        />
        <path
          d="M7.05142 20.7779L7.52048 16.9941L4.56543 17.0723L7.05142 20.7779Z"
          fill="#CC6228"
        />
        <path
          d="M16.4951 16.9941L16.9485 20.7779L19.4502 17.0723L16.4951 16.9941Z"
          fill="#CC6228"
        />
        <path
          d="M18.731 12.8193L13.4463 13.0539L13.931 15.7431L14.7127 14.1171L16.589 14.977L18.731 12.8193Z"
          fill="#CC6228"
        />
        <path
          d="M7.4262 14.977L9.30242 14.1171L10.0685 15.7431L10.5689 13.0539L5.28418 12.8193L7.4262 14.977Z"
          fill="#CC6228"
        />
        <path
          d="M5.28418 12.8193L7.48874 17.119L7.4262 14.977L5.28418 12.8193Z"
          fill="#E27625"
        />
        <path
          d="M16.5889 14.977L16.5107 17.119L18.7309 12.8193L16.5889 14.977Z"
          fill="#E27625"
        />
        <path
          d="M10.5697 13.0547L10.0693 15.7439L10.6947 18.9335L10.8355 14.7433L10.5697 13.0547Z"
          fill="#E27625"
        />
        <path
          d="M13.4465 13.0547L13.1807 14.7277L13.3057 18.9335L13.9312 15.7439L13.4465 13.0547Z"
          fill="#E27625"
        />
        <path
          d="M13.9311 15.7446L13.3057 18.9342L13.7591 19.2469L16.5109 17.1205L16.5891 14.9785L13.9311 15.7446Z"
          fill="#F5841F"
        />
        <path
          d="M7.42676 14.9785L7.4893 17.1205L10.2567 19.2469L10.6945 18.9342L10.0691 15.7446L7.42676 14.9785Z"
          fill="#F5841F"
        />
        <path
          d="M13.9938 22.1855L14.025 21.3099L13.7749 21.1067H10.2257L10.0068 21.3099L10.0224 22.1855L7.05176 20.7783L8.08368 21.6226L10.1944 23.0767H13.8062L15.9169 21.6226L16.9488 20.7783L13.9938 22.1855Z"
          fill="#C0AD9E"
        />
        <path
          d="M13.7583 19.2463L13.3049 18.9336H10.6938L10.256 19.2463L10.0059 21.3101L10.2248 21.1069H13.7739L14.0241 21.3101L13.7583 19.2463Z"
          fill="#2F343B"
        />
        <path
          d="M23.2181 8.34853L23.9998 4.53355L22.8116 1L13.7588 7.66059L17.2454 10.5844L22.1705 12.0228L23.2493 10.7564L22.7803 10.4124L23.5308 9.74007L22.9523 9.28664L23.7028 8.72378L23.2181 8.34853Z"
          fill="#763E1A"
        />
        <path
          d="M0 4.53355L0.797394 8.34853L0.297068 8.72378L1.04756 9.30228L0.469055 9.74007L1.21954 10.4124L0.750488 10.7564L1.84495 12.0228L6.77003 10.5844L10.2567 7.66059L1.18827 1L0 4.53355Z"
          fill="#763E1A"
        />
        <path
          d="M22.1707 12.0224L17.2456 10.584L18.7309 12.8198L16.5107 17.1195L19.4502 17.0726H23.828L22.1707 12.0224Z"
          fill="#F5841F"
        />
        <path
          d="M6.7699 10.584L1.84482 12.0224L0.203125 17.0726H4.56534L7.48912 17.1195L5.28456 12.8198L6.7699 10.584Z"
          fill="#F5841F"
        />
        <path
          d="M13.4464 13.0548L13.7591 7.6607L15.1819 3.83008H8.81836L10.2568 7.6607L10.5695 13.0548L10.6946 14.7434V18.9337H13.3057L13.3213 14.7434L13.4464 13.0548Z"
          fill="#F5841F"
        />
      </g>
      <defs>
        <clipPath id="clip0_883_98">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  mobileLogo: ({width = 20, height = 28, ...rest}: LucideProps) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 28"
      fill="none"
      {...rest}>
      <path
        d="M5.59662 16.8079C4.57417 15.7888 4.01303 14.4328 4.01303 12.9865C4.01303 11.9947 4.27854 11.028 4.7839 10.1902C5.0126 9.81759 5.28593 9.47008 5.59662 9.15827L7.87189 6.88245C8.59424 6.15954 9.00032 5.17948 9.00032 4.15815V0.0800781L2.91193 6.1707C1.02824 8.05383 -0.0326994 10.5846 0.000768589 13.1147C0.0353522 15.5836 1.01373 17.904 2.75797 19.6471L11.0329 27.921V23.8128C11.0329 22.8104 10.6352 21.8493 9.92682 21.1404L5.59662 16.8079Z"
        fill="#FBFBFB"
      />
      <path
        d="M16.8568 6.17865L10.7651 0.0869141V4.16109C10.7651 5.18353 11.1717 6.1647 11.8952 6.88705L14.1665 9.15674C15.189 10.1803 15.7512 11.538 15.7512 12.9849C15.7512 13.9806 15.4846 14.9461 14.9804 15.7778C14.9625 15.8063 14.9447 15.8347 14.9268 15.8621L8.11328 9.04853V13.1935C8.11328 14.1719 8.50207 15.1107 9.19374 15.8024L12.1852 18.7939L15.0194 21.628L16.6671 19.9803C16.6671 19.9803 16.6705 19.9769 16.6722 19.9758L17.0018 19.6462C17.2924 19.3533 17.5641 19.0493 17.8039 18.7386C17.8491 18.6817 17.8921 18.6248 17.9345 18.5679C19.1611 16.9024 19.7914 14.9199 19.7613 12.8377C19.7244 10.3794 18.6925 8.01381 16.8568 6.17753V6.17865Z"
        fill="#FBFBFB"
      />
    </svg>
  ),
  okx: (props: LucideProps) => (
    <svg viewBox="0 0 100 100" fill="none" {...props}>
      <rect width="100" height="100" rx="11" fill="black" />
      <rect x="41" y="41" width="19" height="18" rx="1" fill="white" />
      <rect x="22" y="23" width="19" height="18" rx="1" fill="white" />
      <rect x="60" y="23" width="19" height="18" rx="1" fill="white" />
      <rect x="60" y="59" width="19" height="18" rx="1" fill="white" />
      <rect x="22" y="59" width="19" height="18" rx="1" fill="white" />
    </svg>
  ),
  performance: (props: LucideProps) => (
    <svg viewBox="0 0 17 18" fill="none" {...props}>
      <path
        d="M8.70117 16.5V12.125"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.20117 9H5.57617"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.0879 7.18462C5.69259 7.73774 5.54102 8.42368 5.58009 9.16274C5.61088 9.75117 5.80741 10.3189 6.147 10.8004C6.48659 11.282 6.95541 11.6577 7.49935 11.8842C8.04329 12.1108 8.6402 12.1789 9.2212 12.0808C9.80221 11.9827 10.3436 11.7223 10.783 11.3297C11.2224 10.9371 11.5418 10.4282 11.7044 9.86188C11.8671 9.29553 11.8663 8.69475 11.7021 8.12884C11.538 7.56294 11.2172 7.05497 10.7767 6.66355C10.3363 6.27213 9.79416 6.0132 9.2129 5.91665C9.06876 5.89134 8.93826 5.81576 8.84457 5.70334C8.75089 5.59091 8.70008 5.44892 8.70118 5.30259V2.12524C8.70087 2.03857 8.7186 1.95278 8.75323 1.87333C8.78786 1.79387 8.83864 1.72249 8.90234 1.66371C8.96604 1.60494 9.04126 1.56005 9.12324 1.53191C9.20522 1.50377 9.29215 1.49298 9.37852 1.50024C13.2379 1.84634 16.2535 5.14243 16.2004 9.10493C16.1441 13.144 12.8473 16.4409 8.80821 16.4971C7.81459 16.5113 6.82806 16.3279 5.90593 15.9575C4.9838 15.5872 4.14447 15.0372 3.4367 14.3397C2.72892 13.6422 2.16682 12.811 1.78305 11.8943C1.39928 10.9777 1.20149 9.99396 1.20118 9.00024C1.19863 7.25441 1.81289 5.5638 2.93555 4.22681C2.99101 4.15999 3.05978 4.10546 3.13749 4.0667C3.21519 4.02794 3.30011 4.0058 3.38685 4.00168C3.47358 3.99757 3.56022 4.01157 3.64124 4.0428C3.72227 4.07403 3.79589 4.12179 3.85743 4.18305L6.01368 6.38618C6.11771 6.48944 6.18215 6.62598 6.19571 6.77193C6.20928 6.91788 6.17112 7.06395 6.0879 7.18462Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  portfolio: (props: LucideProps) => (
    <svg viewBox="0 0 20 16" fill="none" {...props}>
      <path
        d="M17.3984 1.25H2.39844C1.57001 1.25 0.898438 1.92157 0.898438 2.75V13.25C0.898438 14.0784 1.57001 14.75 2.39844 14.75H17.3984C18.2269 14.75 18.8984 14.0784 18.8984 13.25V2.75C18.8984 1.92157 18.2269 1.25 17.3984 1.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.898438 7.25H6.22437C6.39711 7.25018 6.56449 7.30998 6.69824 7.4193C6.83198 7.52862 6.92389 7.68075 6.95844 7.85C7.09615 8.52817 7.46408 9.13789 7.99988 9.57583C8.53569 10.0138 9.20642 10.253 9.89844 10.253C10.5905 10.253 11.2612 10.0138 11.797 9.57583C12.3328 9.13789 12.7007 8.52817 12.8384 7.85C12.873 7.68075 12.9649 7.52862 13.0986 7.4193C13.2324 7.30998 13.3998 7.25018 13.5725 7.25H18.8984"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.898438 4.25H18.8984"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  portrait: (props: LucideProps) => (
    <svg viewBox="0 0 22 22" fill="none" {...props}>
      <path
        d="M8 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V15C0 15.5304 0.210714 16.0391 0.585786 16.4142C0.960859 16.7893 1.46957 17 2 17H3V14H2V2H8V10H10V2C10 1.46957 9.78929 0.960859 9.41421 0.585786C9.03914 0.210714 8.53043 0 8 0ZM22 20V14C22 13.4696 21.7893 12.9609 21.4142 12.5858C21.0391 12.2107 20.5304 12 20 12H7C6.46957 12 5.96086 12.2107 5.58579 12.5858C5.21071 12.9609 5 13.4696 5 14V20C5 20.5304 5.21071 21.0391 5.58579 21.4142C5.96086 21.7893 6.46957 22 7 22H20C20.5304 22 21.0391 21.7893 21.4142 21.4142C21.7893 21.0391 22 20.5304 22 20ZM8 20V14H20V20H8ZM22 9H20.5C20.5 6 18.69 3.27 15.92 2.09L15 4L13 0C15.3869 0 17.6761 0.948212 19.364 2.63604C21.0518 4.32387 22 6.61305 22 9Z"
        fill="currentColor"
      />
    </svg>
  ),
  privateKey: () => (
    <svg width="345" height="41" fill="none">
      <path
        fill="#FBFBFB"
        d="M0 .596h13.269v13.269H0zm212.308 26.538h-13.269V13.865h13.269zM225.577.596h13.269v13.269h-13.269zM39.807 40.404H26.538v-13.27h13.27zm238.847 0h-13.269v-13.27h13.269zM145.961.596h13.269v13.269h-13.269zM66.346 27.134H53.077V13.865h13.27zm238.846 0h-13.269V13.865h13.269zm-185.769 13.27h-13.269v-13.27h13.269z"></path>
      <path fill="#FBFBFB" d="M305.192 13.866h-13.269V.596h13.269z"></path>
      <path
        fill="#FBFBFB"
        d="M13.269.596h13.269v13.269H13.269zm185.77 26.538H185.77V13.865h13.269zM238.846.596h13.269v13.269h-13.269zM26.538 40.404H13.27v-13.27h13.27zm238.847 0h-13.269v-13.27h13.269zM119.423.596h13.269v13.269h-13.269zm26.538 39.808h-13.269v-13.27h13.269zm-53.076-13.27h-13.27V13.865h13.27zm238.846 0h-13.269V13.865h13.269z"
        opacity="0.5"></path>
      <path
        fill="#FBFBFB"
        d="M331.731 13.866h-13.269V.596h13.269zM92.885.596h13.269v13.269H92.885zm26.538 26.538h-13.269V13.865h13.269zm53.077 13.27h-13.269v-13.27H172.5zM199.039.596h13.269v13.269h-13.269zM13.269 27.134H0V13.865h13.269zm238.846 0h-13.269V13.865h13.269zM66.346 40.404H53.077v-13.27h13.27zm238.846 0h-13.269v-13.27h13.269z"
        opacity="0.5"></path>
      <path
        fill="#FBFBFB"
        d="M26.539.596h13.269v13.269H26.539zm159.23 26.538H172.5V13.865h13.269zm53.077 13.27h-13.269v-13.27h13.269zM39.808.596h13.269v13.269H39.808zM172.5 27.134h-13.269V13.865H172.5zm53.077 13.27h-13.269v-13.27h13.269z"
        opacity="0.1"></path>
    </svg>
  ),
  privateKeyMobile: () => (
    <svg width="200" height="40" fill="none">
      <path
        fill="#FBFBFB"
        d="M0 .096h13.269v13.269H0zm39.807 39.808H26.538v-13.27h13.27zM145.962.096h13.269v13.269h-13.269zM66.346 26.635H53.077v-13.27h13.27zm53.077 13.269h-13.269v-13.27h13.269z"></path>
      <path
        fill="#FBFBFB"
        d="M13.269.096h13.269v13.269H13.269zm185.769 26.539h-13.269v-13.27h13.269zM26.539 39.904H13.27v-13.27h13.269zM119.423.096h13.269v13.269h-13.269zm26.539 39.808h-13.269v-13.27h13.269zM92.884 26.635H79.615v-13.27h13.27zM92.885.096h13.269v13.269H92.885zm26.538 26.539h-13.269v-13.27h13.269zM172.5 39.904h-13.269v-13.27H172.5zM13.27 26.635H0v-13.27h13.27zm53.076 13.269H53.077v-13.27h13.27z"
        opacity="0.5"></path>
      <path
        fill="#FBFBFB"
        d="M26.538.096h13.269v13.269H26.538zm159.231 26.539H172.5v-13.27h13.269zM39.808.096h13.269v13.269H39.808zM172.5 26.635h-13.269v-13.27H172.5z"
        opacity="0.1"></path>
    </svg>
  ),
  reddit: (props: LucideProps) => (
    <svg viewBox="0 0 33 32" fill="none" {...props}>
      <g clipPath="url(#clip0_270_3875)">
        <path
          d="M16.5 32C25.3366 32 32.5 24.8366 32.5 16C32.5 7.16344 25.3366 0 16.5 0C7.66344 0 0.5 7.16344 0.5 16C0.5 24.8366 7.66344 32 16.5 32Z"
          fill="#FF4500"
          // style="fill:#FF4500;fill:color(display-p3 1.0000 0.2706 0.0000);fill-opacity:1;"
          fillOpacity="1"
        />
        <path
          d="M27.172 16.0002C27.1752 16.2194 27.148 16.4382 27.0904 16.6498C27.0328 16.8614 26.9456 17.0642 26.8312 17.2514C26.7172 17.4386 26.5772 17.609 26.4156 17.7574C26.254 17.9058 26.0724 18.0306 25.876 18.1282C25.8804 18.1866 25.884 18.2454 25.886 18.3042C25.8908 18.4214 25.8908 18.5389 25.886 18.6562C25.884 18.715 25.8804 18.7738 25.876 18.8322C25.876 22.4162 21.7 25.3282 16.548 25.3282C11.396 25.3282 7.22 22.4162 7.22 18.8322C7.2156 18.7738 7.212 18.715 7.21 18.6562C7.20518 18.5389 7.20518 18.4214 7.21 18.3042C7.212 18.2454 7.2156 18.1866 7.22 18.1282C6.9123 17.9867 6.63901 17.7801 6.41903 17.5226C6.19906 17.2652 6.03766 16.963 5.94599 16.637C5.85449 16.3108 5.83499 15.9687 5.88887 15.6342C5.94274 15.2998 6.06869 14.9811 6.25799 14.7002C6.44713 14.4193 6.69511 14.1829 6.98473 14.0075C7.27435 13.832 7.59867 13.7217 7.9352 13.6842C8.27176 13.6464 8.61251 13.6823 8.93382 13.7894C9.25513 13.8965 9.54932 14.0721 9.796 14.3042C10.2539 13.9938 10.7337 13.7169 11.2316 13.4758C11.7296 13.235 12.2444 13.0302 12.772 12.8638C13.2996 12.6974 13.8388 12.5698 14.3848 12.4814C14.9308 12.393 15.4828 12.3446 16.036 12.3362L17.22 6.78416C17.2332 6.71976 17.2592 6.65896 17.2964 6.60456C17.3332 6.55056 17.3808 6.50416 17.4356 6.46856C17.4908 6.43296 17.5524 6.40856 17.6172 6.39656C17.6816 6.38496 17.748 6.38616 17.812 6.40016L21.732 7.18416C22.1276 6.50456 22.958 6.21336 23.6912 6.49656C24.4244 6.77976 24.8436 7.55376 24.6796 8.32256C24.516 9.09136 23.8176 9.62736 23.0328 9.58696C22.2476 9.54656 21.608 8.94176 21.524 8.16016L18.1 7.44016L17.06 12.4322C17.6064 12.4438 18.1516 12.495 18.6908 12.585C19.7706 12.7649 20.8187 13.0999 21.8028 13.5794C22.2943 13.8186 22.7679 14.0929 23.22 14.4002C23.545 14.0881 23.9535 13.8768 24.396 13.7918C24.8385 13.7064 25.2963 13.751 25.714 13.9202C26.1318 14.0892 26.4917 14.3755 26.7504 14.7446C27.0092 15.1136 27.1556 15.5497 27.172 16.0002ZM11.2936 18.2126C11.3744 18.4066 11.492 18.583 11.6408 18.7314C11.7892 18.8802 11.9656 18.9978 12.1596 19.0786C12.3538 19.1589 12.5619 19.2002 12.772 19.2002C13.4192 19.2002 14.0024 18.8102 14.2504 18.2126C14.498 17.6146 14.3608 16.9266 13.9032 16.469C13.4456 16.0114 12.7576 15.8742 12.1596 16.1218C11.562 16.3698 11.172 16.953 11.172 17.6002C11.172 17.8102 11.2132 18.0182 11.2936 18.2126ZM20.4576 22.0534C20.5396 21.9734 20.5864 21.8642 20.588 21.7498C20.5896 21.635 20.5452 21.5246 20.4652 21.4426C20.3852 21.3606 20.276 21.3138 20.1616 21.3122C20.0468 21.3106 19.9364 21.355 19.844 21.4242C19.6034 21.5967 19.3486 21.7486 19.0824 21.8782C18.8161 22.0078 18.5394 22.1147 18.2552 22.1978C17.9712 22.2806 17.6804 22.3394 17.3864 22.3734C17.092 22.4074 16.7956 22.4162 16.5 22.4002C16.2048 22.4134 15.9088 22.4014 15.6156 22.3646C15.3223 22.3281 15.0327 22.2666 14.75 22.1806C14.4668 22.095 14.192 21.9854 13.9276 21.8534C13.6632 21.7214 13.4104 21.567 13.172 21.3922C13.0892 21.3242 12.984 21.2894 12.8768 21.2946C12.7696 21.2998 12.6684 21.345 12.5924 21.4206C12.5168 21.4966 12.4716 21.5978 12.4664 21.705C12.4612 21.8122 12.496 21.9174 12.564 22.0002C12.8452 22.2122 13.144 22.3994 13.4572 22.5602C13.7704 22.721 14.0972 22.8542 14.4332 22.959C14.7692 23.0638 15.1136 23.1394 15.4628 23.1854C15.812 23.231 16.1644 23.2466 16.516 23.2322C16.8676 23.2466 17.22 23.231 17.5692 23.1854C18.2686 23.0934 18.947 22.8819 19.5748 22.5602C19.888 22.3994 20.1868 22.2122 20.468 22.0002L20.4576 22.0534ZM20.164 19.3282C20.3808 19.3306 20.596 19.2886 20.7964 19.2054C20.9968 19.1218 21.178 18.9986 21.3292 18.843C21.4804 18.6874 21.598 18.5026 21.6756 18.2998C21.7533 18.0972 21.7888 17.8809 21.78 17.6642C21.78 17.017 21.39 16.4338 20.7924 16.1858C20.1944 15.9382 19.5064 16.0754 19.0488 16.533C18.5912 16.9906 18.454 17.6786 18.7016 18.2766C18.9496 18.8742 19.5328 19.2642 20.18 19.2642L20.164 19.3282Z"
          fill="white"
          // style="fill:white;fill:white;fill-opacity:1;"
          fillOpacity="1"
        />
      </g>
      <defs>
        <clipPath id="clip0_270_3875">
          <rect
            width="32"
            height="32"
            fill="white"
            // style="fill:white;fill:white;fill-opacity:1;"
            transform="translate(0.5)"
            fillOpacity="1"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  sell: ({width = 12, height = 12, ...rest}: LucideProps) => (
    <svg
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 12 12"
      {...rest}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.104 3.154c-.476 0-.862.343-.862.766v5.363c0 .424.386.767.862.767h6.034c.476 0 .862-.343.862-.767V3.92c0-.423-.386-.766-.862-.766H5.69M2.242 5.368h1.293c.345 0 .69.115.905.345l.474.344a1.87 1.87 0 002.457 0l.474-.344a1.43 1.43 0 01.905-.345H10"></path>
      <ellipse
        cx="4.541"
        cy="2.69"
        stroke="currentColor"
        rx="1.149"
        ry="1.164"></ellipse>
      <path
        stroke="currentColor"
        d="M8.201 5.293c-.373-.679-1.183-.95-1.808-.607-.626.344-.831 1.173-.458 1.852"></path>
    </svg>
  ),
  shielded: ({
    height = 12,
    width = 12,
    fill = '#1C64E0',
    ...rest
  }: LucideProps) => (
    <svg width={width} height={height} viewBox="0 0 9 9" fill="none" {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.8901 0.474962C4.06008 0.329735 4.27632 0.249943 4.49989 0.249943C4.72346 0.249943 4.93969 0.329735 5.10967 0.474962L5.11401 0.478665L5.11399 0.47869C5.715 1.00414 6.53634 1.37511 7.12489 1.37511C7.35695 1.37511 7.57951 1.4673 7.74361 1.63139C7.9077 1.79549 7.99989 2.01805 7.99989 2.25011V4.87511C7.99989 5.94467 7.61966 6.77256 7.0067 7.40144C6.40734 8.01638 5.60771 8.41917 4.79196 8.7035L4.78786 8.70493L4.78786 8.70491C4.59952 8.76873 4.39513 8.76647 4.20835 8.69864C3.39191 8.41624 2.59286 8.01478 1.99386 7.40129C1.38012 6.77272 0.999887 5.94465 0.999887 4.87511V2.25011C0.999887 2.01805 1.09207 1.79549 1.25617 1.63139C1.42026 1.4673 1.64282 1.37511 1.87489 1.37511C2.46308 1.37511 3.28819 1.00073 3.88594 0.478555L3.89008 0.474939L3.8901 0.474962ZM4.49987 1.26958C5.17709 1.84664 6.13796 2.32847 6.99989 2.37192V4.87511C6.99989 5.68055 6.72387 6.25891 6.29058 6.70347C5.85253 7.15289 5.2322 7.48638 4.5069 7.74372C3.77515 7.48767 3.14992 7.15389 2.70936 6.70268C2.27591 6.25876 1.99989 5.68057 1.99989 4.87511V2.3719C2.86237 2.32816 3.82629 1.84298 4.49987 1.26958Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5001 8.25113C4.54304 8.25193 4.58611 8.24535 4.62739 8.23136C6.18739 7.68761 7.49989 6.75011 7.49989 4.87511V2.25011C7.49989 2.15066 7.46038 2.05527 7.39005 1.98495C7.31973 1.91462 7.22434 1.87511 7.12489 1.87511C6.37489 1.87511 5.44114 1.42886 4.78489 0.855111C4.7055 0.787281 4.60452 0.749993 4.5001 0.749943V8.25113Z"
        fill={fill}
      />
    </svg>
  ),
  shield: ({width = 19, height = 20, ...rest}: LucideProps) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 20"
      fill="none"
      {...rest}>
      <path
        d="M1.25 7.76156V2.25C1.25 2.05109 1.32902 1.86032 1.46967 1.71967C1.61032 1.57902 1.80109 1.5 2 1.5H17C17.1989 1.5 17.3897 1.57902 17.5303 1.71967C17.671 1.86032 17.75 2.05109 17.75 2.25V7.75969C17.75 15.6516 11.0647 18.2663 9.73063 18.7097C9.5812 18.7613 9.4188 18.7613 9.26938 18.7097C7.93531 18.2681 1.25 15.6562 1.25 7.76156Z"
        stroke="#58BD7D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeOpacity="1"
        style={{
          stroke: 'color(display-p3 0.3462 0.7411 0.4884)',
          strokeOpacity: 1,
        }}
      />
      <path
        d="M5.75 9.75L8 12L13.25 6.75"
        stroke="#58BD7D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeOpacity="1"
        style={{
          stroke: 'color(display-p3 0.3462 0.7411 0.4884)',
          strokeOpacity: 1,
        }}
      />
    </svg>
  ),
  simpleStaking: (props: LucideProps) => (
    <svg viewBox="0 0 15 17" fill="none" {...props}>
      <path
        d="M11.7011 1H3.29889C2.02925 1 1 2.02925 1 3.29889V11.7011C1 12.9708 2.02925 14 3.29889 14H11.7011C12.9708 14 14 12.9708 14 11.7011V3.29889C14 2.02925 12.9708 1 11.7011 1Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.03711 15.3164H4.89425"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1052 15.3164H11.9624"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.50015 10.7366C9.28761 10.7366 10.7366 9.28761 10.7366 7.50015C10.7366 5.71269 9.28761 4.26367 7.50015 4.26367C5.71269 4.26367 4.26367 5.71269 4.26367 7.50015C4.26367 9.28761 5.71269 10.7366 7.50015 10.7366Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3677 3.33398L3.63257 11.6731"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  station: (props: LucideProps) => (
    <svg viewBox="0 0 27 24" fill="none" {...props}>
      <path
        d="M2.85488 6.0177C3.66042 4.4375 5.34658 3.65524 6.65445 4.25999L6.7217 4.29255L9.68888 5.81334C10.3453 5.62537 11.0468 5.67329 11.6716 5.94879L11.7645 5.99156L13.7886 7.00954L19.7572 10.034C20.8236 10.5784 21.3915 11.7449 21.3832 13.0464L21.3818 13.1229L22.4482 13.6364L20.6081 17.2675L19.5302 16.7217C18.5149 17.532 17.2367 17.7874 16.1607 17.2813L16.0802 17.2419L8.12201 13.2167C8.11654 13.2192 8.11063 13.2204 8.10466 13.2204C8.09869 13.2204 8.09278 13.2192 8.08731 13.2167C7.47895 12.9082 7.00208 12.3908 6.74404 11.7594L6.7103 11.6727L3.7923 10.1806C3.7827 10.1692 3.76999 10.1608 3.75571 10.1564L3.7462 10.1547C2.4293 9.49057 2.03509 7.62475 2.85488 6.0177Z"
        fill="#2B8FF3"
      />
      <path
        d="M4.29233 16.4023L9.37819 19.1191L6.14081 22.4282C6.12027 22.4535 6.09203 22.4715 6.06038 22.4793C6.02873 22.4871 5.99539 22.4843 5.96544 22.4715H5.95118L1.0894 19.9842C1.06777 19.9726 1.04892 19.9565 1.03415 19.9369C1.01938 19.9173 1.00904 19.8947 1.00384 19.8707C0.998648 19.8467 0.99872 19.8219 1.00406 19.7979C1.00939 19.7739 1.01986 19.7514 1.03475 19.7319L4.29233 16.4023ZM8.55839 12.1536L8.58192 12.1614L13.4518 14.6484C13.4882 14.6653 13.5167 14.6954 13.5317 14.7326C13.5467 14.7698 13.547 14.8113 13.5326 14.8487L13.5207 14.8725C13.5161 14.8843 13.5093 14.8951 13.5007 14.9043V14.9217L9.73439 18.774L4.63404 16.0544L8.40631 12.2044C8.4242 12.1824 8.448 12.1659 8.47493 12.1568C8.50186 12.1478 8.53081 12.1468 8.55839 12.1536ZM22.4713 13.6768C23.1209 14.0044 23.2214 15.0797 22.7127 16.086C22.2037 17.0921 21.2751 17.6413 20.6254 17.3136C19.9755 16.9857 19.875 15.9107 20.3837 14.9041C20.8927 13.9008 21.8216 13.3488 22.4713 13.6768ZM8.80861 5.62084C9.10445 5.61763 9.39787 5.67438 9.67119 5.78765C9.43356 5.85419 9.20354 5.94472 8.98398 6.05783L8.90936 6.09514H8.80291C7.86572 6.09514 6.89384 6.7966 6.37344 7.80294C5.81574 8.90694 5.88489 10.1288 6.4913 10.8533C6.53498 11.1282 6.60632 11.3979 6.70421 11.6584C5.51111 10.9339 5.18033 9.15431 5.97685 7.59027C6.58041 6.3684 7.71911 5.62084 8.80861 5.62084ZM15.8553 4.88468L20.9445 7.60167L18.9635 9.63146L13.7885 7.00951L15.8558 4.88468H15.8553ZM19.745 1.00429L19.7688 1.01213L24.6648 3.4991C24.705 3.51834 24.7362 3.55249 24.7517 3.5943C24.7672 3.63612 24.7659 3.68234 24.7479 3.72318C24.7436 3.73334 24.7378 3.74286 24.7308 3.75145L21.2981 7.24524L16.2006 4.5311L19.5932 1.05514C19.6085 1.03633 19.6282 1.02153 19.6505 1.01201C19.6728 1.00249 19.6971 0.998535 19.7212 1.00048L19.745 1.00429Z"
        fill="#A3CFFA"
      />
    </svg>
  ),
  transfer: (props: LucideProps) => (
    <svg viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M4 11.083L15.3333 11.083L11.4375 15.333"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3333 8.25L4 8.25L7.89583 4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  transfer2: ({width = 34, height = 35, ...rest}: LucideProps) => (
    <svg
      viewBox="0 0 34 35"
      fill="none"
      width={width}
      height={height}
      {...rest}>
      <path
        d="M10.3142 19.5972L24.3675 19.5972L20.5367 23.8672"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.3675 16.084L10.3142 16.084L14.145 11.814"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="6.81396"
        y="28.3677"
        width="21.0536"
        height="21.0536"
        transform="rotate(-90 6.81396 28.3677)"
        stroke="currentColor"
        strokeOpacity="0.1"
        strokeWidth="0.02635"
      />
    </svg>
  ),
  transferFrom: ({width = 12, height = 12, ...rest}: LucideProps) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      {...rest}>
      <g
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        clipPath="url(#a01x4h4t324)">
        <path d="M9.222 3.778V2.445A.444.444 0 008.778 2H3a.889.889 0 00-.889.889m0 0A.889.889 0 003 3.778h6.667a.444.444 0 01.444.444V6m-8-3.111v2m8 1.111H8.778a.889.889 0 000 1.778h1.333m0-1.778a.444.444 0 01.444.445v.888a.444.444 0 01-.444.445m0 0v1.778a.444.444 0 01-.444.444H3a.889.889 0 01-.889-.889v-.667m1.956-3.333l1.6 1.556m0 0l-1.6 1.555m1.6-1.555H2.11"></path>
      </g>
      <defs>
        <clipPath id="a01x4h4t324">
          <path fill="currentColor" d="M.667.667h10.667v10.667H.667z"></path>
        </clipPath>
      </defs>
    </svg>
  ),
  transferTo: ({width = 12, height = 12, ...rest}: LucideProps) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      {...rest}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.111 3.778V2.444A.444.444 0 008.667 2H2.889A.889.889 0 002 2.889m0 0a.889.889 0 00.889.889h6.667a.444.444 0 01.444.444v.445M2 2.889V9.11a.889.889 0 00.889.889h6.667A.444.444 0 0010 9.556v-.667M7.956 5.111l1.6 1.556m0 0l-1.6 1.555m1.6-1.555H6"></path>
    </svg>
  ),
  transferDarkRounded: ({width = 34, height = 35, ...rest}: LucideProps) => (
    <svg
      viewBox="0 0 34 35"
      fill="none"
      width={width}
      height={height}
      {...rest}>
      <circle cx="17" cy="17.5" r="17" fill="#1A2736" />
      <circle
        cx="17"
        cy="17.5"
        r="16.25"
        stroke="currentColor"
        strokeOpacity="0.1"
        strokeWidth="1.5"
      />
      <path
        d="M10.3142 19.5972L24.3675 19.5972L20.5367 23.8672"
        stroke="currentColor"
        strokeWidth="1.3175"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.3675 16.084L10.3142 16.084L14.145 11.814"
        stroke="currentColor"
        strokeWidth="1.3175"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  twitter: (props: LucideProps) => (
    <svg viewBox="0 0 33 32" fill="none" {...props}>
      <path
        d="M0.75 16C0.75 24.8366 7.91344 32 16.75 32C25.5866 32 32.75 24.8366 32.75 16C32.75 7.16344 25.5866 0 16.75 0C7.91344 0 0.75 7.16344 0.75 16Z"
        fill="#1DA1F2"
        // style="fill:#1DA1F2;fill:color(display-p3 0.1137 0.6314 0.9490);fill-opacity:1;"
        fillOpacity="1"
      />
      <path
        d="M24.75 11C24.15 11.3 23.55 11.4 22.85 11.5C23.55 11.1 24.05 10.5 24.25 9.7C23.65 10.1 22.95 10.3 22.15 10.5C21.55 9.9 20.65 9.5 19.75 9.5C17.65 9.5 16.05 11.5 16.55 13.5C13.85 13.4 11.45 12.1 9.75 10.1C8.85 11.6 9.35 13.5 10.75 14.5C10.25 14.5 9.75 14.3 9.25 14.1C9.25 15.6 10.35 17 11.85 17.4C11.35 17.5 10.85 17.6 10.35 17.5C10.75 18.8 11.95 19.8 13.45 19.8C12.25 20.7 10.45 21.2 8.75 21C10.25 21.9 11.95 22.5 13.75 22.5C19.85 22.5 23.25 17.4 23.05 12.7C23.75 12.3 24.35 11.7 24.75 11Z"
        fill="white"
        // style="fill:white;fill:white;fill-opacity:1;"
        fillOpacity="1"
      />
    </svg>
  ),
  // wallet: ({width = '18', height = '21', ...rest}: LucideProps) => (
  //   <svg
  //     viewBox="0 0 18 21"
  //     fill="none"
  //     width={width}
  //     height={height}
  //     {...rest}>
  //     <g clipPath="url(#clip0_811_7510)">
  //       <path
  //         d="M14.348 5.43958H4.15022C2.95837 5.43958 1.99219 6.40576 1.99219 7.59761V15.485C1.99219 16.6768 2.95837 17.643 4.15022 17.643H14.348C15.5398 17.643 16.506 16.6768 16.506 15.485V7.59761C16.506 6.40576 15.5398 5.43958 14.348 5.43958Z"
  //         stroke="currentColor"
  //         strokeWidth="1.5"
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //       />
  //       <path
  //         d="M16.5063 10.5427H14.4922V12.5569H16.5063V10.5427Z"
  //         stroke="currentColor"
  //         strokeWidth="1.5"
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //       />
  //       <path
  //         d="M4.17578 5.32962L8.14487 3.12927L8.77112 4.22945"
  //         stroke="currentColor"
  //         strokeWidth="1.5"
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //       />
  //       <path
  //         d="M7.76562 5.32953L12.7249 2.5791L14.4767 5.43955"
  //         stroke="currentColor"
  //         strokeWidth="1.5"
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //       />
  //     </g>
  //     <defs>
  //       <clipPath id="clip0_811_7510">
  //         <rect
  //           width="17.7778"
  //           height="20"
  //           fill="white"
  //           transform="translate(0 0.5)"
  //         />
  //       </clipPath>
  //     </defs>
  //   </svg>
  // ),
  xCorp: (props: LucideProps) => (
    <svg viewBox="0 0 32 32" fill="none" {...props}>
      <path
        d="M0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16Z"
        fill="black"
      />
      <path
        d="M17.7142 15.6226L24.4162 8H22.8286L17.0068 14.6173L12.3604 8H7L14.0278 18.0075L7 26H8.5876L14.7316 19.0104L19.6396 26H25M9.1606 9.17142H11.5996L22.8274 24.8861H20.3878"
        fill="white"
      />
    </svg>
  ),
  xdefi: (props: LucideProps) => (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M14.5382 12.9108C12.7918 13.9989 10.4541 14.5592 8.08662 14.4396C6.09606 14.3416 4.46351 13.6235 3.47638 12.443C2.60857 11.3875 2.27229 9.99477 2.50009 8.39257C2.57729 7.8601 2.73552 7.34272 2.96924 6.85841L3.00179 6.79041C3.82117 5.2081 5.03716 3.86706 6.5301 2.89927C8.02308 1.93149 9.74151 1.3703 11.5164 1.27095C13.2912 1.1716 15.0612 1.53751 16.6523 2.33266C18.2433 3.12781 19.6005 4.32481 20.5903 5.80583C21.5801 7.28685 22.1684 9.00088 22.2973 10.7792C22.4262 12.5576 22.0912 14.3389 21.3253 15.9479C20.5594 17.557 19.3891 18.9383 17.9294 19.9558C16.4698 20.9734 14.7711 21.5923 13.0006 21.7514L13.1091 23C15.0969 22.8224 17.0043 22.1284 18.6434 20.9864C20.2825 19.8445 21.5967 18.2939 22.4565 16.4874C23.3164 14.6809 23.6923 12.681 23.5471 10.6845C23.4019 8.68801 22.7407 6.76391 21.6286 5.10174C20.5165 3.43955 18.9919 2.09665 17.205 1.20531C15.4181 0.313981 13.4304 -0.0950309 11.4379 0.0185731C9.4455 0.132177 7.51689 0.764478 5.84215 1.85318C4.16742 2.94189 2.80434 4.44942 1.8872 6.2273L1.84381 6.31708C1.55387 6.91807 1.35812 7.56034 1.26346 8.22121C0.992268 10.1743 1.41261 11.9125 2.51093 13.2509C3.7123 14.7143 5.66758 15.5847 8.01337 15.699C10.869 15.8432 13.7084 15.0625 15.7233 13.6262L14.5382 12.9108Z"
        fill="#4476F2"
      />
      <path
        d="M16.927 14.3301C15.7907 15.3202 13.1493 17.1156 8.76688 17.3604C3.86106 17.6324 1.81628 16.033 1.7973 16.0166L1.40136 16.5062L1.80001 16.0247L1 16.9877C1.08678 17.0611 3.04748 18.6498 7.6523 18.6498C8.02924 18.6498 8.42518 18.6498 8.83739 18.6171C14.1338 18.3206 17.0436 16.003 18.0579 15.0129L16.927 14.3301Z"
        fill="#4476F2"
      />
      <path
        d="M19.0536 15.6251C18.3817 16.511 17.5546 17.2669 16.6129 17.8557C13.2935 20.0047 9.07109 20.2821 6.11509 20.1325L6.05273 21.3865C6.549 21.411 7.0263 21.4219 7.49006 21.4219C15.8264 21.4219 19.1946 17.6136 20.1356 16.2535L19.0509 15.6143"
        fill="#4476F2"
      />
      <path
        d="M18.7359 10.8774C19.2886 10.8774 19.7365 10.4281 19.7365 9.8738C19.7365 9.3195 19.2886 8.87012 18.7359 8.87012C18.1833 8.87012 17.7354 9.3195 17.7354 9.8738C17.7354 10.4281 18.1833 10.8774 18.7359 10.8774Z"
        fill="#4476F2"
      />
    </svg>
  ),
};

export type IconName = keyof typeof Icons;
